
import { JubileeSevenFever_1Screen } from "./slot/JubileeSevenFever/game_1Screen";
import { JubileeSevenFever } from "./slot/JubileeSevenFever/game";
import { JubileeSevenFever2 } from "./slot/JubileeSevenFever/game2";
import { JubileeSevenFever2_2Screen } from "./slot/JubileeSevenFever/game2_2Screen";
import { JubileeSevenFever3 } from "./slot/JubileeSevenFever/game3";
import { JubileeSevenFever_2Screen } from "./slot/JubileeSevenFever/game_2Screen";
import { MysticRainbow } from "./slot/MysticRainbow/game";
import { MysticRainbow2 } from "./slot/MysticRainbow/game2";
import { MysticRainbow3 } from "./slot/MysticRainbow/game3";
import { MysticRainbow_2Screen } from "./slot/MysticRainbow/game_2Screen";
import { MysticRainbow2_2Screen } from "./slot/MysticRainbow/game2_2Screen";
import { MysticRainbow_1Screen } from "./slot/MysticRainbow/game_1Screen";
import { MysticKingdom } from "./slot/MysticKingdom/game";
import { MysticKingdom2 } from "./slot/MysticKingdom/game2";
import { MysticKingdom3 } from "./slot/MysticKingdom/game3";
import { MysticKingdom_2Screen } from "./slot/MysticKingdom/game_2Screen";
import { MysticKingdom2_2Screen } from "./slot/MysticKingdom/game2_2Screen";
import { MysticKingdom_1Screen } from "./slot/MysticKingdom/game_1Screen";
import { MysticRainbowFillingPot } from "./slot/MysticRainbowFillingPot/game";
import { MysticRainbowFillingPot2 } from "./slot/MysticRainbowFillingPot/game2";
import { MysticRainbowFillingPot2_2Screen } from "./slot/MysticRainbowFillingPot/game2_2Screen";
import { MysticRainbowFillingPot3 } from "./slot/MysticRainbowFillingPot/game3";
import { MysticRainbowFillingPot_1Screen } from "./slot/MysticRainbowFillingPot/game_1Screen";
import { MysticRainbowFillingPot_2Screen } from "./slot/MysticRainbowFillingPot/game_2Screen";
import { EternalFortuneFillingPot } from "./slot/EternalFortuneFillingPot/game";
import { EternalFortuneFillingPot2 } from "./slot/EternalFortuneFillingPot/game2";
import { EternalFortuneFillingPot2_2Screen } from "./slot/EternalFortuneFillingPot/game2_2Screen";
import { EternalFortuneFillingPot_1Screen } from "./slot/EternalFortuneFillingPot/game_1Screen";
import { EternalFortuneFillingPot_2Screen } from "./slot/EternalFortuneFillingPot/game_2Screen";
import { EternalFortuneFillingPot3 } from "./slot/EternalFortuneFillingPot/game3";
import { LavaLandMysticWarriorsFillingPot } from "./slot/LavaLandMysticWarriorsFillingPot/game";
import { LavaLandMysticWarriorsFillingPot2 } from "./slot/LavaLandMysticWarriorsFillingPot/game2";
import { LavaLandMysticWarriorsFillingPot2_2Screen } from "./slot/LavaLandMysticWarriorsFillingPot/game2_2Screen";
import { LavaLandMysticWarriorsFillingPot3 } from "./slot/LavaLandMysticWarriorsFillingPot/game3";
import { LavaLandMysticWarriorsFillingPot_1Screen } from "./slot/LavaLandMysticWarriorsFillingPot/game_1Screen";
import { LavaLandMysticWarriorsFillingPot_2Screen } from "./slot/LavaLandMysticWarriorsFillingPot/game_2Screen";
import { MayanHeroesFillingPot } from "./slot/MayanHeroesFillingPot/game";
import { MayanHeroesFillingPot2 } from "./slot/MayanHeroesFillingPot/game2";
import { MayanHeroesFillingPot2_2Screen } from "./slot/MayanHeroesFillingPot/game2_2Screen";
import { MayanHeroesFillingPot_1Screen } from "./slot/MayanHeroesFillingPot/game_1Screen";
import { MayanHeroesFillingPot_2Screen } from "./slot/MayanHeroesFillingPot/game_2Screen";
import { MayanHeroesFillingPot3 } from "./slot/MayanHeroesFillingPot/game3";
import { AncientSea3DFillingPot } from "./slot/AncientSea3DFillingPot/game";
import { AncientSea3DFillingPot2 } from "./slot/AncientSea3DFillingPot/game2";
import { AncientSea3DFillingPot2_2Screen } from "./slot/AncientSea3DFillingPot/game2_2Screen";
import { AncientSea3DFillingPot3 } from "./slot/AncientSea3DFillingPot/game3";
import { AncientSea3DFillingPot_1Screen } from "./slot/AncientSea3DFillingPot/game_1Screen";
import { AncientSea3DFillingPot_2Screen } from "./slot/AncientSea3DFillingPot/game_2Screen";
import { CloverGirlGreenFillingPot } from "./slot/CloverGirlGreenFillingPot/game";
import { CloverGirlGreenFillingPot2 } from "./slot/CloverGirlGreenFillingPot/game2";
import { CloverGirlGreenFillingPot2_2Screen } from "./slot/CloverGirlGreenFillingPot/game2_2Screen";
import { CloverGirlGreenFillingPot3 } from "./slot/CloverGirlGreenFillingPot/game3";
import { CloverGirlGreenFillingPot_1Screen } from "./slot/CloverGirlGreenFillingPot/game_1Screen";
import { CloverGirlGreenFillingPot_2Screen } from "./slot/CloverGirlGreenFillingPot/game_2Screen";
import { CloverGirlHotFillingPot } from "./slot/CloverGirlHotFillingPot/game";
import { CloverGirlHotFillingPot2 } from "./slot/CloverGirlHotFillingPot/game2";
import { CloverGirlHotFillingPot2_2Screen } from "./slot/CloverGirlHotFillingPot/game2_2Screen";
import { CloverGirlHotFillingPot3 } from "./slot/CloverGirlHotFillingPot/game3";
import { CloverGirlHotFillingPot_1Screen } from "./slot/CloverGirlHotFillingPot/game_1Screen";
import { CloverGirlHotFillingPot_2Screen } from "./slot/CloverGirlHotFillingPot/game_2Screen";
import { CloverGirlDiamondFillingPot } from "./slot/CloverGirlDiamondFillingPot/game";
import { CloverGirlDiamondFillingPot2 } from "./slot/CloverGirlDiamondFillingPot/game2";
import { CloverGirlDiamondFillingPot3 } from "./slot/CloverGirlDiamondFillingPot/game3";
import { CloverGirlDiamondFillingPot_1Screen } from "./slot/CloverGirlDiamondFillingPot/game_1Screen";
import { CloverGirlDiamondFillingPot_2Screen } from "./slot/CloverGirlDiamondFillingPot/game_2Screen";
import { CloverGirlDiamondFillingPot2_2Screen } from "./slot/CloverGirlDiamondFillingPot/game2_2Screen";
import { CloverGirlGoldFillingPot } from "./slot/CloverGirlGoldFillingPot/game";
import { CloverGirlGoldFillingPot2 } from "./slot/CloverGirlGoldFillingPot/game2";
import { CloverGirlGoldFillingPot3 } from "./slot/CloverGirlGoldFillingPot/game3";
import { CloverGirlGoldFillingPot_2Screen } from "./slot/CloverGirlGoldFillingPot/game_2Screen";
import { CloverGirlGoldFillingPot2_2Screen } from "./slot/CloverGirlGoldFillingPot/game2_2Screen";
import { CloverGirlGoldFillingPot_1Screen } from "./slot/CloverGirlGoldFillingPot/game_1Screen";
import { MysticKingdomFillingPot } from "./slot/MysticKingdomFillingPot/game";
import { MysticKingdomFillingPot2 } from "./slot/MysticKingdomFillingPot/game2";
import { MysticKingdomFillingPot3 } from "./slot/MysticKingdomFillingPot/game3";
import { MysticKingdomFillingPot_2Screen } from "./slot/MysticKingdomFillingPot/game_2Screen";
import { MysticKingdomFillingPot2_2Screen } from "./slot/MysticKingdomFillingPot/game2_2Screen";
import { MysticKingdomFillingPot_1Screen } from "./slot/MysticKingdomFillingPot/game_1Screen";
import { SpiritsOfTheThunderFillingPot } from "./slot/SpiritsOfTheThunderFillingPot/game";
import { SpiritsOfTheThunderFillingPot2 } from "./slot/SpiritsOfTheThunderFillingPot/game2";
import { SpiritsOfTheThunderFillingPot2_2Screen } from "./slot/SpiritsOfTheThunderFillingPot/game2_2Screen";
import { SpiritsOfTheThunderFillingPot3 } from "./slot/SpiritsOfTheThunderFillingPot/game3";
import { SpiritsOfTheThunderFillingPot_1Screen } from "./slot/SpiritsOfTheThunderFillingPot/game_1Screen";
import { SpiritsOfTheThunderFillingPot_2Screen } from "./slot/SpiritsOfTheThunderFillingPot/game_2Screen";
import { NordicFuryFillingPot_1Screen } from "./slot/NordicFuryFillinPot/game_1Screen";
import { NordicFuryFillingPot } from "./slot/NordicFuryFillinPot/game";
import { NordicFuryFillingPot2 } from "./slot/NordicFuryFillinPot/game2";
import { NordicFuryFillingPot2_2Screen } from "./slot/NordicFuryFillinPot/game2_2Screen";
import { NordicFuryFillingPot3 } from "./slot/NordicFuryFillinPot/game3";
import { NordicFuryFillingPot_2Screen } from "./slot/NordicFuryFillinPot/game_2Screen";
import { MultigameParams21 } from "./MultigameParams21";
import { SlotGame21 } from "./slot/SlotGame21";
import { AmazingPanda21 } from "./slot/AmazingPanda/gameScreenSpecial";
import { AncientSea21 } from "./slot/AncientSea/gameScreenSpecial";
import { AncientSea3D21 } from "./slot/AncientSea3D/gameScreenSpecial";
import { BambooSecrets21 } from "./slot/BambooSecrets/gameScreenSpecial";
import { AncientSea3DClassic21 } from "./slot/AncientSea3DClassic/gameScreenSpecial";
import { FiestaEnchilada21 } from "./slot/FiestaEnchilada/gameScreenSpecial";
import { FireFruits21 } from "./slot/FireFruits/gameScreenSpecial";
import { GoldAndRum21 } from "./slot/GoldAndRum/gameScreenSpecial";
import { IcyFresh21 } from "./slot/IcyFresh/gameScreenSpecial";
import { LavaLand21 } from "./slot/LavaLand/gameScreenSpecial";
import { CloverGirlDiamondFillingPot21 } from "./slot/CloverGirlDiamondFillingPot/gameScreenSpecial";
import { CloverGirlGoldFillingPot21 } from "./slot/CloverGirlGoldFillingPot/gameScreenSpecial";
import { CloverGirlHotFillingPot21 } from "./slot/CloverGirlHotFillingPot/gameScreenSpecial";
import { LavaLandMysticWarriors21 } from "./slot/LavaLandMysticWarriors/gameScreenSpecial";
import { MayanHeroes21 } from "./slot/MayanHeroes/gameScreenSpecial";
import { MysticKingdomFillingPot21 } from "./slot/MysticKingdomFillingPot/gameScreenSpecial";
import { PandaQuest21 } from "./slot/PandaQuest/gameScreenSpecial";
import { RainbowMagic21 } from "./slot/RainbowMagic/gameScreenSpecial";
import { RainbowTreasure21 } from "./slot/RainbowTreasure/gameScreenSpecial";
import { AncientSea3DFillingPot21 } from "./slot/AncientSea3DFillingPot/gameScreenSpecial";
import { AsianDreams21 } from "./slot/AsianDreams/gameScreenSpecial";
import { BurningFruits21 } from "./slot/BurningFruits/gameScreenSpecial";
import { BurningHot21 } from "./slot/BurningHot/gameScreenSpecial";
import { BurningSeven21 } from "./slot/BurningSeven/gameScreenSpecial";
import { Catillionare21 } from "./slot/Catillionare/gameScreenSpecial";
import { ChilliBlast21 } from "./slot/ChilliBlast/gameScreenSpecial";
import { CloverGirlGreenFillingPot21 } from "./slot/CloverGirlGreenFillingPot/gameScreenSpecial";
import { CrazySeven21 } from "./slot/CrazySeven/gameScreenSpecial";
import { EternalFortuneBulk21 } from "./slot/EternalFortuneBulk/gameScreenSpecial";
import { EternalFortuneFillingPot21 } from "./slot/EternalFortuneFillingPot/gameScreenSpecial";
import { EternalFortuneReel21 } from "./slot/EternalFortuneReel/gameScreenSpecial";
import { EternalFortuneStack21 } from "./slot/EternalFortuneStack/gameScreenSpecial";
import { FairyMagicForest21 } from "./slot/FairyMagicForest/gameScreenSpecial";
import { FairyMagicForestClassic21 } from "./slot/FairyMagicForestClassic/gameScreenSpecial";
import { FireBlastClassic21 } from "./slot/FireBlastClassic/gameScreenSpecial";
import { FireBlastDeluxClassic21 } from "./slot/FireBlastDeluxClassic/gameScreenSpecial";
import { IceBlast21 } from "./slot/IceBlast/gameScreenSpecial";
import { IceBlastDeluxClassic21 } from "./slot/IceBlastDeluxClassic/gameScreenSpecial";
import { IcyMania21 } from "./slot/IcyMania/gameScreenSpecial";
import { IcyManiaDeluxClassic21 } from "./slot/IcyManiaDeluxClassic/gameScreenSpecial";
import { JubileeSevenFever21 } from "./slot/JubileeSevenFever/gameScreenSpecial";
import { LavaLand202321 } from "./slot/LavaLand2023/gameScreenSpecial";
import { LavaLandMysticWarriorsFillingPot21 } from "./slot/LavaLandMysticWarriorsFillingPot/gameScreenSpecial";
import { LuckyFire21 } from "./slot/LuckyFire/gameScreenSpecial";
import { LuckyFire1021 } from "./slot/LuckyFire10/gameScreenSpecial";
import { LuckyFire521 } from "./slot/LuckyFire5/gameScreenSpecial";
import { LuckyHot21 } from "./slot/LuckyHot/gameScreenSpecial";
import { LuckyIce21 } from "./slot/LuckyIce/gameScreenSpecial";
import { LuckyIce1021 } from "./slot/LuckyIce10/gameScreenSpecial";
import { LuckyIce521 } from "./slot/LuckyIce5/gameScreenSpecial";
import { LuckySeven21 } from "./slot/LuckySeven/gameScreenSpecial";
import { MayanHeroesFillingPot21 } from "./slot/MayanHeroesFillingPot/gameScreenSpecial";
import { MundoMistico21 } from "./slot/MundoMistico/gameScreenSpecial";
import { MysticCanyon21 } from "./slot/MysticCanyon/gameScreenSpecial";
import { MysticKingdom21 } from "./slot/MysticKingdom/gameScreenSpecial";
import { MysticRainbow21 } from "./slot/MysticRainbow/gameScreenSpecial";
import { MysticRainbowFillingPot21 } from "./slot/MysticRainbowFillingPot/gameScreenSpecial";
import { RainbowMagic202321 } from "./slot/RainbowMagic2023/gameScreenSpecial";
import { RainbowMagicClassic21 } from "./slot/RainbowMagicClassic/gameScreenSpecial";
import { RapidLavaLand21 } from "./slot/RapidLavaLand/gameScreenSpecial";
import { RoyalChalice21 } from "./slot/RoyalChalice/gameScreenSpecial";
import { RoyalDice21 } from "./slot/RoyalDice/gameScreenSpecial";
import { RoyalKing21 } from "./slot/RoyalKing/gameScreenSpecial";
import { RoyalKingDeluxe21 } from "./slot/RoyalKingDeluxe/gameScreenSpecial";
import { SweetBlast21 } from "./slot/SweetBlast/gameScreenSpecial";
import { SweetSweet21 } from "./slot/SweetSweet/gameScreenSpecial";
import { TikiBay21 } from "./slot/TikiBay/gameScreenSpecial";
import { TikiBayClassic21 } from "./slot/TikiBayClassic/gameScreenSpecial";
import { WildChalice21 } from "./slot/WildChalice/gameScreenSpecial";
import { BurningFruits1021 } from "./slot/BurningFruits10/gameScreenSpecial";
import { BurningFruits10021 } from "./slot/BurningFruits100/gameScreenSpecial";
import { BurningFruits2021 } from "./slot/BurningFruits20/gameScreenSpecial";
import { BurningFruits4021 } from "./slot/BurningFruits40/gameScreenSpecial";
import { BurningFruits521 } from "./slot/BurningFruits5/gameScreenSpecial";
import { LuckyFire10021 } from "./slot/LuckyFire100/gameScreenSpecial";
import { LuckyFire4021 } from "./slot/LuckyFire40/gameScreenSpecial";
import { LuckyFire40Delux21 } from "./slot/LuckyFire40Delux/gameScreenSpecial";
import { LuckyIce10021 } from "./slot/LuckyIce100/gameScreenSpecial";
import { LuckyIce2021 } from "./slot/LuckyIce20/gameScreenSpecial";
import { LuckyIce4021 } from "./slot/LuckyIce40/gameScreenSpecial";
import { LuckyIce40Delux21 } from "./slot/LuckyIce40Delux/gameScreenSpecial";
import { WildFire10021 } from "./slot/WildFire100/gameScreenSpecial";
import { WildFire2021 } from "./slot/WildFire20/gameScreenSpecial";
import { LuckyFire2021 } from "./slot/LuckyFire 20/gameScreenSpecial";
import { SecretsOfAnubis21 } from "./slot/SecretsOfAnubis/gameScreenSpecial";
import { SecretsOfAnubisClassic21 } from "./slot/SecretsOfAnubisClassic/gameScreenSpecial";
import { SevenFever21 } from "./slot/SevenFever/gameScreenSpecial";
import { SevenFeverClassic21 } from "./slot/SevenFeverClassic/gameScreenSpecial";
import { SevenForever21 } from "./slot/SevenForever/gameScreenSpecial";
import { ShiningChalice21 } from "./slot/ShiningChalice/gameScreenSpecial";
import { SpiritOfThunder21 } from "./slot/SpiritOfThunder/gameScreenSpecial";
import { SpiritsOfTheThunderFillingPot21 } from "./slot/SpiritsOfTheThunderFillingPot/gameScreenSpecial";
import { SpiritsOfTheThunderReloaded21 } from "./slot/SpiritsOfTheThunderReloaded/gameScreenSpecial";
import { StickyChilli21 } from "./slot/StickyChilli/gameScreenSpecial";
import { StickyChilliClassic21 } from "./slot/StickyChilliClassic/gameScreenSpecial";
import { JuicyIce21 } from "./slot/JuicyIce/gameScreenSpecial";
import { GoldAndRumBAFillingPot } from "./slot/GoldAndRumBAFillingPot/game";
import { GoldAndRumBAFillingPot2 } from "./slot/GoldAndRumBAFillingPot/game2";
import { GoldAndRumBAFillingPot2_2Screen } from "./slot/GoldAndRumBAFillingPot/game2_2Screen";
import { GoldAndRumBAFillingPot3 } from "./slot/GoldAndRumBAFillingPot/game3";
import { GoldAndRumBAFillingPot_1Screen } from "./slot/GoldAndRumBAFillingPot/game_1Screen";
import { GoldAndRumBAFillingPot_2Screen } from "./slot/GoldAndRumBAFillingPot/game_2Screen";
import { GoldAndRumBAFillingPot21 } from "./slot/GoldAndRumBAFillingPot/gameScreenSpecial";
import { MultigameParams } from "./MultigameParams";
import { MultigameParams2 } from "./MultigameParams2";
import { MultigameParams3 } from "./MultigameParams3";
import { SlotGameInitData } from "./SlotGameInitData";
import { AmazingPanda } from "./slot/AmazingPanda/game";
import { AmazingPanda2 } from "./slot/AmazingPanda/game2";
import { AmazingPanda2_2Screen } from "./slot/AmazingPanda/game2_2Screen";
import { AmazingPanda3 } from "./slot/AmazingPanda/game3";
import { AmazingPanda_1Screen } from "./slot/AmazingPanda/game_1Screen";
import { AmazingPanda_2Screen } from "./slot/AmazingPanda/game_2Screen";
import { AmazingPanda_Responsive } from "./slot/AmazingPanda/game_responsive";
import { AmazingPandaLink_1Screen } from "./slot/AmazingPandaLink/game_1Screen";
import { AmazingPandaLink_Responsive } from "./slot/AmazingPandaLink/game_responsive";
import { AncientSea } from "./slot/AncientSea/game";
import { AncientSea2 } from "./slot/AncientSea/game2";
import { AncientSea2_2Screen } from "./slot/AncientSea/game2_2Screen";
import { AncientSea3 } from "./slot/AncientSea/game3";
import { AncientSea_1Screen } from "./slot/AncientSea/game_1Screen";
import { AncientSea_2Screen } from "./slot/AncientSea/game_2Screen";
import { AncientSea_Responsive } from "./slot/AncientSea/game_responsive";
import { AncientSea3D } from "./slot/AncientSea3D/game";
import { AncientSea3D2 } from "./slot/AncientSea3D/game2";
import { AncientSea3D2_2Screen } from "./slot/AncientSea3D/game2_2Screen";
import { AncientSea3D3 } from "./slot/AncientSea3D/game3";
import { AncientSea3D_1Screen } from "./slot/AncientSea3D/game_1Screen";
import { AncientSea3D_2Screen } from "./slot/AncientSea3D/game_2Screen";
import { AncientSea3D_Responsive } from "./slot/AncientSea3D/game_responsive";
import { AncientSea3DClassic } from "./slot/AncientSea3DClassic/game";
import { AncientSea3DClassic2 } from "./slot/AncientSea3DClassic/game2";
import { AncientSea3DClassic2_2Screen } from "./slot/AncientSea3DClassic/game2_2Screen";
import { AncientSea3DClassic3 } from "./slot/AncientSea3DClassic/game3";
import { AncientSea3DClassic_1Screen } from "./slot/AncientSea3DClassic/game_1Screen";
import { AncientSea3DClassic_2Screen } from "./slot/AncientSea3DClassic/game_2Screen";
import { AncientSea3DClassic_Responsive } from "./slot/AncientSea3DClassic/game_responsive";
import { AncientSeaLink_1Screen } from "./slot/AncientSeaLink/game_1Screen";
import { AncientSeaLink_Responsive } from "./slot/AncientSeaLink/game_responsive";
import { AsianDreams } from "./slot/AsianDreams/game";
import { AsianDreams2 } from "./slot/AsianDreams/game2";
import { AsianDreams2_2Screen } from "./slot/AsianDreams/game2_2Screen";
import { AsianDreams3 } from "./slot/AsianDreams/game3";
import { AsianDreams_1Screen } from "./slot/AsianDreams/game_1Screen";
import { AsianDreams_2Screen } from "./slot/AsianDreams/game_2Screen";
import { AsianDreams_Responsive } from "./slot/AsianDreams/game_responsive";
import { BambooSecrets } from "./slot/BambooSecrets/game";
import { BambooSecrets2 } from "./slot/BambooSecrets/game2";
import { BambooSecrets2_2Screen } from "./slot/BambooSecrets/game2_2Screen";
import { BambooSecrets3 } from "./slot/BambooSecrets/game3";
import { BambooSecrets_1Screen } from "./slot/BambooSecrets/game_1Screen";
import { BambooSecrets_2Screen } from "./slot/BambooSecrets/game_2Screen";
import { BambooSecrets_Responsive } from "./slot/BambooSecrets/game_responsive";
import { BambooSecretsLink_1Screen } from "./slot/BambooSecretsLink/game_1Screen";
import { BambooSecretsLink_Responsive } from "./slot/BambooSecretsLink/game_responsive";
import { BurningFruits } from "./slot/BurningFruits/game";
import { BurningFruits2 } from "./slot/BurningFruits/game2";
import { BurningFruits2_2Screen } from "./slot/BurningFruits/game2_2Screen";
import { BurningFruits3 } from "./slot/BurningFruits/game3";
import { BurningFruits_1Screen } from "./slot/BurningFruits/game_1Screen";
import { BurningFruits_2Screen } from "./slot/BurningFruits/game_2Screen";
import { BurningFruits_Responsive } from "./slot/BurningFruits/game_responsive";
import { BurningFruits10 } from "./slot/BurningFruits10/game";
import { BurningFruits10_2 } from "./slot/BurningFruits10/game2";
import { BurningFruits10_2_2Screen } from "./slot/BurningFruits10/game2_2Screen";
import { BurningFruits10_3 } from "./slot/BurningFruits10/game3";
import { BurningFruits10_1Screen } from "./slot/BurningFruits10/game_1Screen";
import { BurningFruits10_2Screen } from "./slot/BurningFruits10/game_2Screen";
import { BurningFruits10_Responsive } from "./slot/BurningFruits10/game_responsive";
import { BurningFruits100 } from "./slot/BurningFruits100/game";
import { BurningFruits100_2 } from "./slot/BurningFruits100/game2";
import { BurningFruits100_2_2Screen } from "./slot/BurningFruits100/game2_2Screen";
import { BurningFruits100_3 } from "./slot/BurningFruits100/game3";
import { BurningFruits100_1Screen } from "./slot/BurningFruits100/game_1Screen";
import { BurningFruits100_2Screen } from "./slot/BurningFruits100/game_2Screen";
import { BurningFruits100_Responsive } from "./slot/BurningFruits100/game_responsive";
import { BurningFruits20 } from "./slot/BurningFruits20/game";
import { BurningFruits20_2 } from "./slot/BurningFruits20/game2";
import { BurningFruits20_2_2Screen } from "./slot/BurningFruits20/game2_2Screen";
import { BurningFruits20_3 } from "./slot/BurningFruits20/game3";
import { BurningFruits20_1Screen } from "./slot/BurningFruits20/game_1Screen";
import { BurningFruits20_2Screen } from "./slot/BurningFruits20/game_2Screen";
import { BurningFruits20_Responsive } from "./slot/BurningFruits20/game_responsive";
import { BurningFruits40 } from "./slot/BurningFruits40/game";
import { BurningFruits40_2 } from "./slot/BurningFruits40/game2";
import { BurningFruits40_2_2Screen } from "./slot/BurningFruits40/game2_2Screen";
import { BurningFruits40_3 } from "./slot/BurningFruits40/game3";
import { BurningFruits40_1Screen } from "./slot/BurningFruits40/game_1Screen";
import { BurningFruits40_2Screen } from "./slot/BurningFruits40/game_2Screen";
import { BurningFruits40_Responsive } from "./slot/BurningFruits40/game_responsive";
import { BurningFruits5 } from "./slot/BurningFruits5/game";
import { BurningFruits5_2 } from "./slot/BurningFruits5/game2";
import { BurningFruits5_2_2Screen } from "./slot/BurningFruits5/game2_2Screen";
import { BurningFruits5_3 } from "./slot/BurningFruits5/game3";
import { BurningFruits5_1Screen } from "./slot/BurningFruits5/game_1Screen";
import { BurningFruits5_2Screen } from "./slot/BurningFruits5/game_2Screen";
import { BurningFruits5_Responsive } from "./slot/BurningFruits5/game_responsive";
import { BurningHot } from "./slot/BurningHot/game";
import { BurningHot2 } from "./slot/BurningHot/game2";
import { BurningHot2_2Screen } from "./slot/BurningHot/game2_2Screen";
import { BurningHot3 } from "./slot/BurningHot/game3";
import { BurningHot_1Screen } from "./slot/BurningHot/game_1Screen";
import { BurningHot_2Screen } from "./slot/BurningHot/game_2Screen";
import { BurningHot_Responsive } from "./slot/BurningHot/game_responsive";
import { BurningSeven } from "./slot/BurningSeven/game";
import { BurningSeven2 } from "./slot/BurningSeven/game2";
import { BurningSeven2_2Screen } from "./slot/BurningSeven/game2_2Screen";
import { BurningSeven3 } from "./slot/BurningSeven/game3";
import { BurningSeven_1Screen } from "./slot/BurningSeven/game_1Screen";
import { BurningSeven_2Screen } from "./slot/BurningSeven/game_2Screen";
import { BurningSeven_Responsive } from "./slot/BurningSeven/game_responsive";
import { Catillionare } from "./slot/Catillionare/game";
import { Catillionare2 } from "./slot/Catillionare/game2";
import { Catillionare2_2Screen } from "./slot/Catillionare/game2_2Screen";
import { Catillionare3 } from "./slot/Catillionare/game3";
import { Catillionare_1Screen } from "./slot/Catillionare/game_1Screen";
import { Catillionare_2Screen } from "./slot/Catillionare/game_2Screen";
import { Catillionare_Responsive } from "./slot/Catillionare/game_responsive";
import { ChilliBlast } from "./slot/ChilliBlast/game";
import { ChilliBlast2 } from "./slot/ChilliBlast/game2";
import { ChilliBlast2_2Screen } from "./slot/ChilliBlast/game2_2Screen";
import { ChilliBlast3 } from "./slot/ChilliBlast/game3";
import { ChilliBlast_1Screen } from "./slot/ChilliBlast/game_1Screen";
import { ChilliBlast_2Screen } from "./slot/ChilliBlast/game_2Screen";
import { ChilliBlast_Responsive } from "./slot/ChilliBlast/game_responsive";
import { CloverGirlDiamond_Responsive } from "./slot/CloverGirlDiamond/game_responsive";
import { CloverGirlDiamond40_Responsive } from "./slot/CloverGirlDiamond40/game_responsive";
import { CloverGirlGold_Responsive } from "./slot/CloverGirlGold/game_responsive";
import { CloverGirlGold10_Responsive } from "./slot/CloverGirlGold10/game_responsive";
import { CloverGirlGold10Deluxe_Responsive } from "./slot/CloverGirlGold10Deluxe/game_responsive";
import { CloverGirlGreen_Responsive } from "./slot/CloverGirlGreen/game_responsive";
import { CloverGirlGreen20_Responsive } from "./slot/CloverGirlGreen20/game_responsive";
import { CloverGirlGreen20Deluxe_Responsive } from "./slot/CloverGirlGreen20Deluxe/game_responsive";
import { CloverGirlHot_Responsive } from "./slot/CloverGirlHot/game_responsive";
import { CloverGirlHot50_Responsive } from "./slot/CloverGirlHot50/game_responsive";
import { CloverGirlHot50Deluxe_Responsive } from "./slot/CloverGirlHot50Deluxe/game_responsive";
import { CrazySeven } from "./slot/CrazySeven/game";
import { CrazySeven2 } from "./slot/CrazySeven/game2";
import { CrazySeven2_2Screen } from "./slot/CrazySeven/game2_2Screen";
import { CrazySeven3 } from "./slot/CrazySeven/game3";
import { CrazySeven_1Screen } from "./slot/CrazySeven/game_1Screen";
import { CrazySeven_2Screen } from "./slot/CrazySeven/game_2Screen";
import { CrazySeven_Responsive } from "./slot/CrazySeven/game_responsive";
import { EternalFortuneBulk } from "./slot/EternalFortuneBulk/game";
import { EternalFortuneBulk2 } from "./slot/EternalFortuneBulk/game2";
import { EternalFortuneBulk2_2Screen } from "./slot/EternalFortuneBulk/game2_2Screen";
import { EternalFortuneBulk3 } from "./slot/EternalFortuneBulk/game3";
import { EternalFortuneBulk_1Screen } from "./slot/EternalFortuneBulk/game_1Screen";
import { EternalFortuneBulk_2Screen } from "./slot/EternalFortuneBulk/game_2Screen";
import { EternalFortuneBulk_Responsive } from "./slot/EternalFortuneBulk/game_responsive";
import { EternalFortuneReel } from "./slot/EternalFortuneReel/game";
import { EternalFortuneReel2 } from "./slot/EternalFortuneReel/game2";
import { EternalFortuneReel2_2Screen } from "./slot/EternalFortuneReel/game2_2Screen";
import { EternalFortuneReel3 } from "./slot/EternalFortuneReel/game3";
import { EternalFortuneReel_1Screen } from "./slot/EternalFortuneReel/game_1Screen";
import { EternalFortuneReel_2Screen } from "./slot/EternalFortuneReel/game_2Screen";
import { EternalFortuneReel_Responsive } from "./slot/EternalFortuneReel/game_responsive";
import { EternalFortuneStack } from "./slot/EternalFortuneStack/game";
import { EternalFortuneStack2 } from "./slot/EternalFortuneStack/game2";
import { EternalFortuneStack2_2Screen } from "./slot/EternalFortuneStack/game2_2Screen";
import { EternalFortuneStack3 } from "./slot/EternalFortuneStack/game3";
import { EternalFortuneStack_1Screen } from "./slot/EternalFortuneStack/game_1Screen";
import { EternalFortuneStack_2Screen } from "./slot/EternalFortuneStack/game_2Screen";
import { EternalFortuneStack_Responsive } from "./slot/EternalFortuneStack/game_responsive";
import { FairyMagicForest } from "./slot/FairyMagicForest/game";
import { FairyMagicForest2 } from "./slot/FairyMagicForest/game2";
import { FairyMagicForest2_2Screen } from "./slot/FairyMagicForest/game2_2Screen";
import { FairyMagicForest3 } from "./slot/FairyMagicForest/game3";
import { FairyMagicForest_1Screen } from "./slot/FairyMagicForest/game_1Screen";
import { FairyMagicForest_2Screen } from "./slot/FairyMagicForest/game_2Screen";
import { FairyMagicForest_Responsive } from "./slot/FairyMagicForest/game_responsive";
import { FairyMagicForestClassic } from "./slot/FairyMagicForestClassic/game";
import { FairyMagicForestClassic2 } from "./slot/FairyMagicForestClassic/game2";
import { FairyMagicForestClassic2_2Screen } from "./slot/FairyMagicForestClassic/game2_2Screen";
import { FairyMagicForestClassic3 } from "./slot/FairyMagicForestClassic/game3";
import { FairyMagicForestClassic_1Screen } from "./slot/FairyMagicForestClassic/game_1Screen";
import { FairyMagicForestClassic_2Screen } from "./slot/FairyMagicForestClassic/game_2Screen";
import { FairyMagicForestClassic_Responsive } from "./slot/FairyMagicForestClassic/game_responsive";
import { FiestaEnchilada } from "./slot/FiestaEnchilada/game";
import { FiestaEnchilada2 } from "./slot/FiestaEnchilada/game2";
import { FiestaEnchilada2_2Screen } from "./slot/FiestaEnchilada/game2_2Screen";
import { FiestaEnchilada3 } from "./slot/FiestaEnchilada/game3";
import { FiestaEnchilada_1Screen } from "./slot/FiestaEnchilada/game_1Screen";
import { FiestaEnchilada_2Screen } from "./slot/FiestaEnchilada/game_2Screen";
import { FiestaEnchilada_Responsive } from "./slot/FiestaEnchilada/game_responsive";
import { FireBlast_1Screen } from "./slot/FireBlast/game_1Screen";
import { FireBlast_Responsive } from "./slot/FireBlast/game_responsive";
import { FireBlastClassic } from "./slot/FireBlastClassic/game";
import { FireBlastClassic2 } from "./slot/FireBlastClassic/game2";
import { FireBlastClassic2_2Screen } from "./slot/FireBlastClassic/game2_2Screen";
import { FireBlastClassic3 } from "./slot/FireBlastClassic/game3";
import { FireBlastClassic_1Screen } from "./slot/FireBlastClassic/game_1Screen";
import { FireBlastClassic_2Screen } from "./slot/FireBlastClassic/game_2Screen";
import { FireBlastClassic_Responsive } from "./slot/FireBlastClassic/game_responsive";
import { FireBlastDeluxClassic } from "./slot/FireBlastDeluxClassic/game";
import { FireBlastDeluxClassic2 } from "./slot/FireBlastDeluxClassic/game2";
import { FireBlastDeluxClassic2_2Screen } from "./slot/FireBlastDeluxClassic/game2_2Screen";
import { FireBlastDeluxClassic3 } from "./slot/FireBlastDeluxClassic/game3";
import { FireBlastDeluxClassic_1Screen } from "./slot/FireBlastDeluxClassic/game_1Screen";
import { FireBlastDeluxClassic_2Screen } from "./slot/FireBlastDeluxClassic/game_2Screen";
import { FireBlastDeluxClassic_Responsive } from "./slot/FireBlastDeluxClassic/game_responsive";
import { FireFruits } from "./slot/FireFruits/game";
import { FireFruits2 } from "./slot/FireFruits/game2";
import { FireFruits2_2Screen } from "./slot/FireFruits/game2_2Screen";
import { FireFruits3 } from "./slot/FireFruits/game3";
import { FireFruits_1Screen } from "./slot/FireFruits/game_1Screen";
import { FireFruits_2Screen } from "./slot/FireFruits/game_2Screen";
import { FireFruits_Responsive } from "./slot/FireFruits/game_responsive";
import { FireFruitsLink_1Screen } from "./slot/FireFruitsLink/game_1Screen";
import { FireFruitsLink_Responsive } from "./slot/FireFruitsLink/game_responsive";
import { FireMania_1Screen } from "./slot/FireMania/game_1Screen";
import { FireMania_Responsive } from "./slot/FireMania/game_responsive";
import { FreezingFruits_1Screen } from "./slot/FreezingFruits/game_1Screen";
import { FreezingFruits_Responsive } from "./slot/FreezingFruits/game_responsive";
import { GoldAndRum } from "./slot/GoldAndRum/game";
import { GoldAndRum2 } from "./slot/GoldAndRum/game2";
import { GoldAndRum2_2Screen } from "./slot/GoldAndRum/game2_2Screen";
import { GoldAndRum3 } from "./slot/GoldAndRum/game3";
import { GoldAndRum_1Screen } from "./slot/GoldAndRum/game_1Screen";
import { GoldAndRum_2Screen } from "./slot/GoldAndRum/game_2Screen";
import { GoldAndRum_Responsive } from "./slot/GoldAndRum/game_responsive";
import { GoldAndRumLink_1Screen } from "./slot/GoldAndRumLink/game_1Screen";
import { GoldAndRumLink_Responsive } from "./slot/GoldAndRumLink/game_responsive";
import { IceBlast } from "./slot/IceBlast/game";
import { IceBlast2 } from "./slot/IceBlast/game2";
import { IceBlast2_2Screen } from "./slot/IceBlast/game2_2Screen";
import { IceBlast3 } from "./slot/IceBlast/game3";
import { IceBlast_1Screen } from "./slot/IceBlast/game_1Screen";
import { IceBlast_2Screen } from "./slot/IceBlast/game_2Screen";
import { IceBlast_Responsive } from "./slot/IceBlast/game_responsive";
import { IceBlastDeluxClassic } from "./slot/IceBlastDeluxClassic/game";
import { IceBlastDeluxClassic2 } from "./slot/IceBlastDeluxClassic/game2";
import { IceBlastDeluxClassic2_2Screen } from "./slot/IceBlastDeluxClassic/game2_2Screen";
import { IceBlastDeluxClassic3 } from "./slot/IceBlastDeluxClassic/game3";
import { IceBlastDeluxClassic_1Screen } from "./slot/IceBlastDeluxClassic/game_1Screen";
import { IceBlastDeluxClassic_2Screen } from "./slot/IceBlastDeluxClassic/game_2Screen";
import { IceBlastDeluxClassic_Responsive } from "./slot/IceBlastDeluxClassic/game_responsive";
import { IcyFresh } from "./slot/IcyFresh/game";
import { IcyFresh2 } from "./slot/IcyFresh/game2";
import { IcyFresh2_2Screen } from "./slot/IcyFresh/game2_2Screen";
import { IcyFresh3 } from "./slot/IcyFresh/game3";
import { IcyFresh_1Screen } from "./slot/IcyFresh/game_1Screen";
import { IcyFresh_2Screen } from "./slot/IcyFresh/game_2Screen";
import { IcyFresh_Responsive } from "./slot/IcyFresh/game_responsive";
import { IcyFreshLink_1Screen } from "./slot/IcyFreshLink/game_1Screen";
import { IcyFreshLink_Responsive } from "./slot/IcyFreshLink/game_responsive";
import { IcyMania } from "./slot/IcyMania/game";
import { IcyMania2 } from "./slot/IcyMania/game2";
import { IcyMania2_2Screen } from "./slot/IcyMania/game2_2Screen";
import { IcyMania3 } from "./slot/IcyMania/game3";
import { IcyMania_1Screen } from "./slot/IcyMania/game_1Screen";
import { IcyMania_2Screen } from "./slot/IcyMania/game_2Screen";
import { IcyMania_Responsive } from "./slot/IcyMania/game_responsive";
import { IcyManiaDeluxClassic } from "./slot/IcyManiaDeluxClassic/game";
import { IcyManiaDeluxClassic2 } from "./slot/IcyManiaDeluxClassic/game2";
import { IcyManiaDeluxClassic2_2Screen } from "./slot/IcyManiaDeluxClassic/game2_2Screen";
import { IcyManiaDeluxClassic3 } from "./slot/IcyManiaDeluxClassic/game3";
import { IcyManiaDeluxClassic_1Screen } from "./slot/IcyManiaDeluxClassic/game_1Screen";
import { IcyManiaDeluxClassic_2Screen } from "./slot/IcyManiaDeluxClassic/game_2Screen";
import { IcyManiaDeluxClassic_Responsive } from "./slot/IcyManiaDeluxClassic/game_responsive";
import { JuicyIce } from "./slot/JuicyIce/game";
import { JuicyIce2 } from "./slot/JuicyIce/game2";
import { JuicyIce2_2Screen } from "./slot/JuicyIce/game2_2Screen";
import { JuicyIce3 } from "./slot/JuicyIce/game3";
import { JuicyIce_1Screen } from "./slot/JuicyIce/game_1Screen";
import { JuicyIce_2Screen } from "./slot/JuicyIce/game_2Screen";
import { JuicyIce_Responsive } from "./slot/JuicyIce/game_responsive";
import { LavaLand } from "./slot/LavaLand/game";
import { LavaLand2 } from "./slot/LavaLand/game2";
import { LavaLand2_2Screen } from "./slot/LavaLand/game2_2Screen";
import { LavaLand3 } from "./slot/LavaLand/game3";
import { LavaLand_1Screen } from "./slot/LavaLand/game_1Screen";
import { LavaLand_2Screen } from "./slot/LavaLand/game_2Screen";
import { LavaLand_Responsive } from "./slot/LavaLand/game_responsive";
import { LavaLand2023 } from "./slot/LavaLand2023/game";
import { LavaLand20232 } from "./slot/LavaLand2023/game2";
import { LavaLand20232_2Screen } from "./slot/LavaLand2023/game2_2Screen";
import { LavaLand20233 } from "./slot/LavaLand2023/game3";
import { LavaLand2023_1Screen } from "./slot/LavaLand2023/game_1Screen";
import { LavaLand2023_2Screen } from "./slot/LavaLand2023/game_2Screen";
import { LavaLand2023_Responsive } from "./slot/LavaLand2023/game_responsive";
import { LavaLandLink_1Screen } from "./slot/LavaLandLink/game_1Screen";
import { LavaLandLink_Responsive } from "./slot/LavaLandLink/game_responsive";
import { LavaLandMysticWarriors } from "./slot/LavaLandMysticWarriors/game";
import { LavaLandMysticWarriors2 } from "./slot/LavaLandMysticWarriors/game2";
import { LavaLandMysticWarriors2_2Screen } from "./slot/LavaLandMysticWarriors/game2_2Screen";
import { LavaLandMysticWarriors3 } from "./slot/LavaLandMysticWarriors/game3";
import { LavaLandMysticWarriors_1Screen } from "./slot/LavaLandMysticWarriors/game_1Screen";
import { LavaLandMysticWarriors_2Screen } from "./slot/LavaLandMysticWarriors/game_2Screen";
import { LavaLandMysticWarriors_Responsive } from "./slot/LavaLandMysticWarriors/game_responsive";
import { LuckyFire20 } from "./slot/LuckyFire 20/game";
import { LuckyFire20_2 } from "./slot/LuckyFire 20/game2";
import { LuckyFire20_2_2Screen } from "./slot/LuckyFire 20/game2_2Screen";
import { LuckyFire20_3 } from "./slot/LuckyFire 20/game3";
import { LuckyFire20_1Screen } from "./slot/LuckyFire 20/game_1Screen";
import { LuckyFire20_2Screen } from "./slot/LuckyFire 20/game_2Screen";
import { LuckyFire20_Responsive } from "./slot/LuckyFire 20/game_responsive";
import { LuckyFire } from "./slot/LuckyFire/game";
import { LuckyFire2 } from "./slot/LuckyFire/game2";
import { LuckyFire2_2Screen } from "./slot/LuckyFire/game2_2Screen";
import { LuckyFire3 } from "./slot/LuckyFire/game3";
import { LuckyFire_1Screen } from "./slot/LuckyFire/game_1Screen";
import { LuckyFire_2Screen } from "./slot/LuckyFire/game_2Screen";
import { LuckyFire_Responsive } from "./slot/LuckyFire/game_responsive";
import { LuckyFire10 } from "./slot/LuckyFire10/game";
import { LuckyFire102 } from "./slot/LuckyFire10/game2";
import { LuckyFire102_2Screen } from "./slot/LuckyFire10/game2_2Screen";
import { LuckyFire103 } from "./slot/LuckyFire10/game3";
import { LuckyFire10_1Screen } from "./slot/LuckyFire10/game_1Screen";
import { LuckyFire10_2Screen } from "./slot/LuckyFire10/game_2Screen";
import { LuckyFire10_Responsive } from "./slot/LuckyFire10/game_responsive";
import { LuckyFire100 } from "./slot/LuckyFire100/game";
import { LuckyFire100_2 } from "./slot/LuckyFire100/game2";
import { LuckyFire100_2_2Screen } from "./slot/LuckyFire100/game2_2Screen";
import { LuckyFire100_3 } from "./slot/LuckyFire100/game3";
import { LuckyFire100_1Screen } from "./slot/LuckyFire100/game_1Screen";
import { LuckyFire100_2Screen } from "./slot/LuckyFire100/game_2Screen";
import { LuckyFire100_Responsive } from "./slot/LuckyFire100/game_responsive";
import { LuckyFire40 } from "./slot/LuckyFire40/game";
import { LuckyFire40_2 } from "./slot/LuckyFire40/game2";
import { LuckyFire40_2_2Screen } from "./slot/LuckyFire40/game2_2Screen";
import { LuckyFire40_3 } from "./slot/LuckyFire40/game3";
import { LuckyFire40_1Screen } from "./slot/LuckyFire40/game_1Screen";
import { LuckyFire40_2Screen } from "./slot/LuckyFire40/game_2Screen";
import { LuckyFire40_Responsive } from "./slot/LuckyFire40/game_responsive";
import { LuckyFire40Delux } from "./slot/LuckyFire40Delux/game";
import { LuckyFire40Delux_2 } from "./slot/LuckyFire40Delux/game2";
import { LuckyFire40Delux_2_2Screen } from "./slot/LuckyFire40Delux/game2_2Screen";
import { LuckyFire40Delux_3 } from "./slot/LuckyFire40Delux/game3";
import { LuckyFire40Delux_1Screen } from "./slot/LuckyFire40Delux/game_1Screen";
import { LuckyFire40Delux_2Screen } from "./slot/LuckyFire40Delux/game_2Screen";
import { LuckyFire40Delux_Responsive } from "./slot/LuckyFire40Delux/game_responsive";
import { LuckyFire5 } from "./slot/LuckyFire5/game";
import { LuckyFire52 } from "./slot/LuckyFire5/game2";
import { LuckyFire52_2Screen } from "./slot/LuckyFire5/game2_2Screen";
import { LuckyFire53 } from "./slot/LuckyFire5/game3";
import { LuckyFire5_1Screen } from "./slot/LuckyFire5/game_1Screen";
import { LuckyFire5_2Screen } from "./slot/LuckyFire5/game_2Screen";
import { LuckyFire5_Responsive } from "./slot/LuckyFire5/game_responsive";
import { LuckyHot } from "./slot/LuckyHot/game";
import { LuckyHot2 } from "./slot/LuckyHot/game2";
import { LuckyHot2_2Screen } from "./slot/LuckyHot/game2_2Screen";
import { LuckyHot3 } from "./slot/LuckyHot/game3";
import { LuckyHot_1Screen } from "./slot/LuckyHot/game_1Screen";
import { LuckyHot_2Screen } from "./slot/LuckyHot/game_2Screen";
import { LuckyHot_Responsive } from "./slot/LuckyHot/game_responsive";
import { LuckyIce } from "./slot/LuckyIce/game";
import { LuckyIce2 } from "./slot/LuckyIce/game2";
import { LuckyIce2_2Screen } from "./slot/LuckyIce/game2_2Screen";
import { LuckyIce3 } from "./slot/LuckyIce/game3";
import { LuckyIce_1Screen } from "./slot/LuckyIce/game_1Screen";
import { LuckyIce_2Screen } from "./slot/LuckyIce/game_2Screen";
import { LuckyIce_Responsive } from "./slot/LuckyIce/game_responsive";
import { LuckyIce10 } from "./slot/LuckyIce10/game";
import { LuckyIce102 } from "./slot/LuckyIce10/game2";
import { LuckyIce102_2Screen } from "./slot/LuckyIce10/game2_2Screen";
import { LuckyIce103 } from "./slot/LuckyIce10/game3";
import { LuckyIce10_1Screen } from "./slot/LuckyIce10/game_1Screen";
import { LuckyIce10_2Screen } from "./slot/LuckyIce10/game_2Screen";
import { LuckyIce10_Responsive } from "./slot/LuckyIce10/game_responsive";
import { LuckyIce100 } from "./slot/LuckyIce100/game";
import { LuckyIce100_2 } from "./slot/LuckyIce100/game2";
import { LuckyIce100_2_2Screen } from "./slot/LuckyIce100/game2_2Screen";
import { LuckyIce100_3 } from "./slot/LuckyIce100/game3";
import { LuckyIce100_1Screen } from "./slot/LuckyIce100/game_1Screen";
import { LuckyIce100_2Screen } from "./slot/LuckyIce100/game_2Screen";
import { LuckyIce100_Responsive } from "./slot/LuckyIce100/game_responsive";
import { LuckyIce20 } from "./slot/LuckyIce20/game";
import { LuckyIce20_2 } from "./slot/LuckyIce20/game2";
import { LuckyIce20_2_2Screen } from "./slot/LuckyIce20/game2_2Screen";
import { LuckyIce20_3 } from "./slot/LuckyIce20/game3";
import { LuckyIce20_1Screen } from "./slot/LuckyIce20/game_1Screen";
import { LuckyIce20_2Screen } from "./slot/LuckyIce20/game_2Screen";
import { LuckyIce20_Responsive } from "./slot/LuckyIce20/game_responsive";
import { LuckyIce40 } from "./slot/LuckyIce40/game";
import { LuckyIce40_2 } from "./slot/LuckyIce40/game2";
import { LuckyIce40_2_2Screen } from "./slot/LuckyIce40/game2_2Screen";
import { LuckyIce40_3 } from "./slot/LuckyIce40/game3";
import { LuckyIce40_1Screen } from "./slot/LuckyIce40/game_1Screen";
import { LuckyIce40_2Screen } from "./slot/LuckyIce40/game_2Screen";
import { LuckyIce40_Responsive } from "./slot/LuckyIce40/game_responsive";
import { LuckyIce40Delux } from "./slot/LuckyIce40Delux/game";
import { LuckyIce40Delux_2 } from "./slot/LuckyIce40Delux/game2";
import { LuckyIce40Delux_2_2Screen } from "./slot/LuckyIce40Delux/game2_2Screen";
import { LuckyIce40Delux_3 } from "./slot/LuckyIce40Delux/game3";
import { LuckyIce40Delux_1Screen } from "./slot/LuckyIce40Delux/game_1Screen";
import { LuckyIce40Delux_2Screen } from "./slot/LuckyIce40Delux/game_2Screen";
import { LuckyIce40Delux_Responsive } from "./slot/LuckyIce40Delux/game_responsive";
import { LuckyIce5 } from "./slot/LuckyIce5/game";
import { LuckyIce52 } from "./slot/LuckyIce5/game2";
import { LuckyIce52_2Screen } from "./slot/LuckyIce5/game2_2Screen";
import { LuckyIce53 } from "./slot/LuckyIce5/game3";
import { LuckyIce5_1Screen } from "./slot/LuckyIce5/game_1Screen";
import { LuckyIce5_2Screen } from "./slot/LuckyIce5/game_2Screen";
import { LuckyIce5_Responsive } from "./slot/LuckyIce5/game_responsive";
import { LuckySeven } from "./slot/LuckySeven/game";
import { LuckySeven2 } from "./slot/LuckySeven/game2";
import { LuckySeven2_2Screen } from "./slot/LuckySeven/game2_2Screen";
import { LuckySeven3 } from "./slot/LuckySeven/game3";
import { LuckySeven_1Screen } from "./slot/LuckySeven/game_1Screen";
import { LuckySeven_2Screen } from "./slot/LuckySeven/game_2Screen";
import { LuckySeven_Responsive } from "./slot/LuckySeven/game_responsive";
import { MayanHeroes } from "./slot/MayanHeroes/game";
import { MayanHeroes2 } from "./slot/MayanHeroes/game2";
import { MayanHeroes2_2Screen } from "./slot/MayanHeroes/game2_2Screen";
import { MayanHeroes3 } from "./slot/MayanHeroes/game3";
import { MayanHeroes_1Screen } from "./slot/MayanHeroes/game_1Screen";
import { MayanHeroes_2Screen } from "./slot/MayanHeroes/game_2Screen";
import { MayanHeroes_Responsive } from "./slot/MayanHeroes/game_responsive";
import { MayanHeroesLink_1Screen } from "./slot/MayanHeroesLink/game_1Screen";
import { MayanHeroesLink_Responsive } from "./slot/MayanHeroesLink/game_responsive";
import { MundoMistico } from "./slot/MundoMistico/game";
import { MundoMistico2 } from "./slot/MundoMistico/game2";
import { MundoMistico2_2Screen } from "./slot/MundoMistico/game2_2Screen";
import { MundoMistico3 } from "./slot/MundoMistico/game3";
import { MundoMistico_1Screen } from "./slot/MundoMistico/game_1Screen";
import { MundoMistico_2Screen } from "./slot/MundoMistico/game_2Screen";
import { MundoMistico_Responsive } from "./slot/MundoMistico/game_responsive";
import { MysticCanyon } from "./slot/MysticCanyon/game";
import { MysticCanyon2 } from "./slot/MysticCanyon/game2";
import { MysticCanyon2_2Screen } from "./slot/MysticCanyon/game2_2Screen";
import { MysticCanyon3 } from "./slot/MysticCanyon/game3";
import { MysticCanyon_1Screen } from "./slot/MysticCanyon/game_1Screen";
import { MysticCanyon_2Screen } from "./slot/MysticCanyon/game_2Screen";
import { MysticCanyon_Responsive } from "./slot/MysticCanyon/game_responsive";
import { PandaBlast_1Screen } from "./slot/PandaBlast/game_1Screen";
import { PandaBlast_Responsive } from "./slot/PandaBlast/game_responsive";
import { PandaQuest } from "./slot/PandaQuest/game";
import { PandaQuest2 } from "./slot/PandaQuest/game2";
import { PandaQuest2_2Screen } from "./slot/PandaQuest/game2_2Screen";
import { PandaQuest3 } from "./slot/PandaQuest/game3";
import { PandaQuest_2Screen } from "./slot/PandaQuest/game_2Screen";
import { RainbowBlast_1Screen } from "./slot/RainbowBlast/game_1Screen";
import { RainbowBlast_Responsive } from "./slot/RainbowBlast/game_responsive";
import { RainbowMagic } from "./slot/RainbowMagic/game";
import { RainbowMagic2 } from "./slot/RainbowMagic/game2";
import { RainbowMagic2_2Screen } from "./slot/RainbowMagic/game2_2Screen";
import { RainbowMagic3 } from "./slot/RainbowMagic/game3";
import { RainbowMagic_1Screen } from "./slot/RainbowMagic/game_1Screen";
import { RainbowMagic_2Screen } from "./slot/RainbowMagic/game_2Screen";
import { RainbowMagic_Responsive } from "./slot/RainbowMagic/game_responsive";
import { RainbowMagic2023 } from "./slot/RainbowMagic2023/game";
import { RainbowMagic20232 } from "./slot/RainbowMagic2023/game2";
import { RainbowMagic20232_2Screen } from "./slot/RainbowMagic2023/game2_2Screen";
import { RainbowMagic20233 } from "./slot/RainbowMagic2023/game3";
import { RainbowMagic2023_1Screen } from "./slot/RainbowMagic2023/game_1Screen";
import { RainbowMagic2023_2Screen } from "./slot/RainbowMagic2023/game_2Screen";
import { RainbowMagic2023_Responsive } from "./slot/RainbowMagic2023/game_responsive";
import { RainbowMagicClassic } from "./slot/RainbowMagicClassic/game";
import { RainbowMagicClassic2 } from "./slot/RainbowMagicClassic/game2";
import { RainbowMagicClassic2_2Screen } from "./slot/RainbowMagicClassic/game2_2Screen";
import { RainbowMagicClassic3 } from "./slot/RainbowMagicClassic/game3";
import { RainbowMagicClassic_1Screen } from "./slot/RainbowMagicClassic/game_1Screen";
import { RainbowMagicClassic_2Screen } from "./slot/RainbowMagicClassic/game_2Screen";
import { RainbowMagicClassic_Responsive } from "./slot/RainbowMagicClassic/game_responsive";
import { RainbowTreasure } from "./slot/RainbowTreasure/game";
import { RainbowTreasure2 } from "./slot/RainbowTreasure/game2";
import { RainbowTreasure2_2Screen } from "./slot/RainbowTreasure/game2_2Screen";
import { RainbowTreasure3 } from "./slot/RainbowTreasure/game3";
import { RainbowTreasure_2Screen } from "./slot/RainbowTreasure/game_2Screen";
import { RainbowTreasure_Responsive } from "./slot/RainbowTreasure/game_responsive";
import { RainbowTreasureLink_1Screen } from "./slot/RainbowTreasureLink/game_1Screen";
import { RainbowTreasureLink_Responsive } from "./slot/RainbowTreasureLink/game_responsive";
import { RapidLavaLand } from "./slot/RapidLavaLand/game";
import { RapidLavaLand2 } from "./slot/RapidLavaLand/game2";
import { RapidLavaLand2_2Screen } from "./slot/RapidLavaLand/game2_2Screen";
import { RapidLavaLand3 } from "./slot/RapidLavaLand/game3";
import { RapidLavaLand_1Screen } from "./slot/RapidLavaLand/game_1Screen";
import { RapidLavaLand_2Screen } from "./slot/RapidLavaLand/game_2Screen";
import { RapidLavaLand_Responsive } from "./slot/RapidLavaLand/game_responsive";
import { RoyalChalice } from "./slot/RoyalChalice/game";
import { RoyalChalice2 } from "./slot/RoyalChalice/game2";
import { RoyalChalice2_2Screen } from "./slot/RoyalChalice/game2_2Screen";
import { RoyalChalice3 } from "./slot/RoyalChalice/game3";
import { RoyalChalice_1Screen } from "./slot/RoyalChalice/game_1Screen";
import { RoyalChalice_2Screen } from "./slot/RoyalChalice/game_2Screen";
import { RoyalChalice_Responsive } from "./slot/RoyalChalice/game_responsive";
import { RoyalDice } from "./slot/RoyalDice/game";
import { RoyalDice2 } from "./slot/RoyalDice/game2";
import { RoyalDice2_2Screen } from "./slot/RoyalDice/game2_2Screen";
import { RoyalDice3 } from "./slot/RoyalDice/game3";
import { RoyalDice_1Screen } from "./slot/RoyalDice/game_1Screen";
import { RoyalDice_2Screen } from "./slot/RoyalDice/game_2Screen";
import { RoyalDice_Responsive } from "./slot/RoyalDice/game_responsive";
import { RoyalKing } from "./slot/RoyalKing/game";
import { RoyalKing2 } from "./slot/RoyalKing/game2";
import { RoyalKing2_2Screen } from "./slot/RoyalKing/game2_2Screen";
import { RoyalKing3 } from "./slot/RoyalKing/game3";
import { RoyalKing_1Screen } from "./slot/RoyalKing/game_1Screen";
import { RoyalKing_2Screen } from "./slot/RoyalKing/game_2Screen";
import { RoyalKing_Responsive } from "./slot/RoyalKing/game_responsive";
import { RoyalKingDeluxe } from "./slot/RoyalKingDeluxe/game";
import { RoyalKingDeluxe2 } from "./slot/RoyalKingDeluxe/game2";
import { RoyalKingDeluxe2_2Screen } from "./slot/RoyalKingDeluxe/game2_2Screen";
import { RoyalKingDeluxe3 } from "./slot/RoyalKingDeluxe/game3";
import { RoyalKingDeluxe_1Screen } from "./slot/RoyalKingDeluxe/game_1Screen";
import { RoyalKingDeluxe_2Screen } from "./slot/RoyalKingDeluxe/game_2Screen";
import { RoyalKingDeluxe_Responsive } from "./slot/RoyalKingDeluxe/game_responsive";
import { SeaBlast_1Screen } from "./slot/SeaBlast/game_1Screen";
import { SeaBlast_Responsive } from "./slot/SeaBlast/game_responsive";
import { SecretsOfAnubis } from "./slot/SecretsOfAnubis/game";
import { SecretsOfAnubis2 } from "./slot/SecretsOfAnubis/game2";
import { SecretsOfAnubis2_2Screen } from "./slot/SecretsOfAnubis/game2_2Screen";
import { SecretsOfAnubis3 } from "./slot/SecretsOfAnubis/game3";
import { SecretsOfAnubis_1Screen } from "./slot/SecretsOfAnubis/game_1Screen";
import { SecretsOfAnubis_2Screen } from "./slot/SecretsOfAnubis/game_2Screen";
import { SecretsOfAnubis_Responsive } from "./slot/SecretsOfAnubis/game_responsive";
import { SecretsOfAnubisClassic } from "./slot/SecretsOfAnubisClassic/game";
import { SecretsOfAnubisClassic2 } from "./slot/SecretsOfAnubisClassic/game2";
import { SecretsOfAnubisClassic2_2Screen } from "./slot/SecretsOfAnubisClassic/game2_2Screen";
import { SecretsOfAnubisClassic3 } from "./slot/SecretsOfAnubisClassic/game3";
import { SecretsOfAnubisClassic_1Screen } from "./slot/SecretsOfAnubisClassic/game_1Screen";
import { SecretsOfAnubisClassic_2Screen } from "./slot/SecretsOfAnubisClassic/game_2Screen";
import { SecretsOfAnubisClassic_Responsive } from "./slot/SecretsOfAnubisClassic/game_responsive";
import { SecretsOfAnubisLink_1Screen } from "./slot/SecretsOfAnubisLink/game_1Screen";
import { SecretsOfAnubisLink_Responsive } from "./slot/SecretsOfAnubisLink/game_responsive";
import { SevenBlast_1Screen } from "./slot/SevenBlast/game_1Screen";
import { SevenBlast_Responsive } from "./slot/SevenBlast/game_responsive";
import { SevenFever } from "./slot/SevenFever/game";
import { SevenFever2 } from "./slot/SevenFever/game2";
import { SevenFever2_2Screen } from "./slot/SevenFever/game2_2Screen";
import { SevenFever3 } from "./slot/SevenFever/game3";
import { SevenFever_1Screen } from "./slot/SevenFever/game_1Screen";
import { SevenFever_2Screen } from "./slot/SevenFever/game_2Screen";
import { SevenFever_Responsive } from "./slot/SevenFever/game_responsive";
import { SevenFeverClassic } from "./slot/SevenFeverClassic/game";
import { SevenFeverClassic_2 } from "./slot/SevenFeverClassic/game2";
import { SevenFeverClassic_2_2Screen } from "./slot/SevenFeverClassic/game2_2Screen";
import { SevenFeverClassic_3 } from "./slot/SevenFeverClassic/game3";
import { SevenFeverClassic_1Screen } from "./slot/SevenFeverClassic/game_1Screen";
import { SevenFeverClassic_2Screen } from "./slot/SevenFeverClassic/game_2Screen";
import { SevenFeverClassic_Responsive } from "./slot/SevenFeverClassic/game_responsive";
import { SevenFeverLink_1Screen } from "./slot/SevenFeverLink/game_1Screen";
import { SevenFeverLink_Responsive } from "./slot/SevenFeverLink/game_responsive";
import { SevenForever } from "./slot/SevenForever/game";
import { SevenForever2 } from "./slot/SevenForever/game2";
import { SevenForever2_2Screen } from "./slot/SevenForever/game2_2Screen";
import { SevenForever3 } from "./slot/SevenForever/game3";
import { SevenForever_2Screen } from "./slot/SevenForever/game_2Screen";
import { SevenMania_1Screen } from "./slot/SevenMania/game_1Screen";
import { SevenMania_Responsive } from "./slot/SevenMania/game_responsive";
import { ShiningChalice } from "./slot/ShiningChalice/game";
import { ShiningChalice2 } from "./slot/ShiningChalice/game2";
import { ShiningChalice2_2Screen } from "./slot/ShiningChalice/game2_2Screen";
import { ShiningChalice3 } from "./slot/ShiningChalice/game3";
import { ShiningChalice_1Screen } from "./slot/ShiningChalice/game_1Screen";
import { ShiningChalice_2Screen } from "./slot/ShiningChalice/game_2Screen";
import { ShiningChalice_Responsive } from "./slot/ShiningChalice/game_responsive";
import { SlotGame } from "./slot/SlotGame";
import { SlotGame2 } from "./slot/SlotGame2";
import { SlotGame3 } from "./slot/SlotGame3";
import { SpiritOfThunder } from "./slot/SpiritOfThunder/game";
import { SpiritOfThunder2 } from "./slot/SpiritOfThunder/game2";
import { SpiritOfThunder2_2Screen } from "./slot/SpiritOfThunder/game2_2Screen";
import { SpiritOfThunder3 } from "./slot/SpiritOfThunder/game3";
import { SpiritOfThunder_1Screen } from "./slot/SpiritOfThunder/game_1Screen";
import { SpiritOfThunder_2Screen } from "./slot/SpiritOfThunder/game_2Screen";
import { SpiritOfThunder_Responsive } from "./slot/SpiritOfThunder/game_responsive";
import { SpiritsOfTheThunderReloaded } from "./slot/SpiritsOfTheThunderReloaded/game";
import { SpiritsOfTheThunderReloaded2 } from "./slot/SpiritsOfTheThunderReloaded/game2";
import { SpiritsOfTheThunderReloaded2_2Screen } from "./slot/SpiritsOfTheThunderReloaded/game2_2Screen";
import { SpiritsOfTheThunderReloaded3 } from "./slot/SpiritsOfTheThunderReloaded/game3";
import { SpiritsOfTheThunderReloaded_1Screen } from "./slot/SpiritsOfTheThunderReloaded/game_1Screen";
import { SpiritsOfTheThunderReloaded_2Screen } from "./slot/SpiritsOfTheThunderReloaded/game_2Screen";
import { SpiritsOfTheThunderReloaded_Responsive } from "./slot/SpiritsOfTheThunderReloaded/game_responsive";
import { StickyChilli } from "./slot/StickyChilli/game";
import { StickyChilli2 } from "./slot/StickyChilli/game2";
import { StickyChilli2_2Screen } from "./slot/StickyChilli/game2_2Screen";
import { StickyChilli3 } from "./slot/StickyChilli/game3";
import { StickyChilli_1Screen } from "./slot/StickyChilli/game_1Screen";
import { StickyChilli_2Screen } from "./slot/StickyChilli/game_2Screen";
import { StickyChilli_Responsive } from "./slot/StickyChilli/game_responsive";
import { StickyChilliClassic } from "./slot/StickyChilliClassic/game";
import { StickyChilliClassic2 } from "./slot/StickyChilliClassic/game2";
import { StickyChilliClassic2_2Screen } from "./slot/StickyChilliClassic/game2_2Screen";
import { StickyChilliClassic3 } from "./slot/StickyChilliClassic/game3";
import { StickyChilliClassic_1Screen } from "./slot/StickyChilliClassic/game_1Screen";
import { StickyChilliClassic_2Screen } from "./slot/StickyChilliClassic/game_2Screen";
import { StickyChilliClassic_Responsive } from "./slot/StickyChilliClassic/game_responsive";
import { StickyChilliLink_1Screen } from "./slot/StickyChilliLink/game_1Screen";
import { StickyChilliLink_Responsive } from "./slot/StickyChilliLink/game_responsive";
import { SweetBlast } from "./slot/SweetBlast/game";
import { SweetBlast2 } from "./slot/SweetBlast/game2";
import { SweetBlast2_2Screen } from "./slot/SweetBlast/game2_2Screen";
import { SweetBlast3 } from "./slot/SweetBlast/game3";
import { SweetBlast_1Screen } from "./slot/SweetBlast/game_1Screen";
import { SweetBlast_2Screen } from "./slot/SweetBlast/game_2Screen";
import { SweetBlast_Responsive } from "./slot/SweetBlast/game_responsive";
import { SweetSweet } from "./slot/SweetSweet/game";
import { SweetSweet2 } from "./slot/SweetSweet/game2";
import { SweetSweet2_2Screen } from "./slot/SweetSweet/game2_2Screen";
import { SweetSweet3 } from "./slot/SweetSweet/game3";
import { SweetSweet_1Screen } from "./slot/SweetSweet/game_1Screen";
import { SweetSweet_2Screen } from "./slot/SweetSweet/game_2Screen";
import { SweetSweet_Responsive } from "./slot/SweetSweet/game_responsive";
import { SweetSweetLink_1Screen } from "./slot/SweetSweetLink/game_1Screen";
import { SweetSweetLink_Responsive } from "./slot/SweetSweetLink/game_responsive";
import { TikiBay } from "./slot/TikiBay/game";
import { TikiBay2 } from "./slot/TikiBay/game2";
import { TikiBay2_2Screen } from "./slot/TikiBay/game2_2Screen";
import { TikiBay3 } from "./slot/TikiBay/game3";
import { TikiBay_1Screen } from "./slot/TikiBay/game_1Screen";
import { TikiBay_2Screen } from "./slot/TikiBay/game_2Screen";
import { TikiBay_Responsive } from "./slot/TikiBay/game_responsive";
import { TikiBayClassic } from "./slot/TikiBayClassic/game";
import { TikiBayClassic2 } from "./slot/TikiBayClassic/game2";
import { TikiBayClassic2_2Screen } from "./slot/TikiBayClassic/game2_2Screen";
import { TikiBayClassic3 } from "./slot/TikiBayClassic/game3";
import { TikiBayClassic_1Screen } from "./slot/TikiBayClassic/game_1Screen";
import { TikiBayClassic_2Screen } from "./slot/TikiBayClassic/game_2Screen";
import { TikiBayClassic_Responsive } from "./slot/TikiBayClassic/game_responsive";
import { TikiBayLink_1Screen } from "./slot/TikiBayLink/game_1Screen";
import { TikiBayLink_Responsive } from "./slot/TikiBayLink/game_responsive";
import { VintageSeven_Responsive } from "./slot/VintageSeven/game_responsive";
import { VintageSevenClassic_Responsive } from "./slot/VintageSevenClassic/game_responsive";
import { Wild7_1Screen } from "./slot/Wild7/game_1Screen";
import { Wild7_Responsive } from "./slot/Wild7/game_responsive";
import { WildChalice } from "./slot/WildChalice/game";
import { WildChalice2 } from "./slot/WildChalice/game2";
import { WildChalice2_2Screen } from "./slot/WildChalice/game2_2Screen";
import { WildChalice3 } from "./slot/WildChalice/game3";
import { WildChalice_1Screen } from "./slot/WildChalice/game_1Screen";
import { WildChalice_2Screen } from "./slot/WildChalice/game_2Screen";
import { WildChalice_Responsive } from "./slot/WildChalice/game_responsive";
import { WildChilli_1Screen } from "./slot/WildChilli/game_1Screen";
import { WildChilli_Responsive } from "./slot/WildChilli/game_responsive";
import { WildFire_1Screen } from "./slot/WildFire/game_1Screen";
import { WildFire_Responsive } from "./slot/WildFire/game_responsive";
import { WildFire100 } from "./slot/WildFire100/game";
import { WildFire100_2 } from "./slot/WildFire100/game2";
import { WildFire100_2_2Screen } from "./slot/WildFire100/game2_2Screen";
import { WildFire100_3 } from "./slot/WildFire100/game3";
import { WildFire100_1Screen } from "./slot/WildFire100/game_1Screen";
import { WildFire100_2Screen } from "./slot/WildFire100/game_2Screen";
import { WildFire100_Responsive } from "./slot/WildFire100/game_responsive";
import { WildFire20 } from "./slot/WildFire20/game";
import { WildFire20_2 } from "./slot/WildFire20/game2";
import { WildFire20_2_2Screen } from "./slot/WildFire20/game2_2Screen";
import { WildFire20_3 } from "./slot/WildFire20/game3";
import { WildFire20_1Screen } from "./slot/WildFire20/game_1Screen";
import { WildFire20_2Screen } from "./slot/WildFire20/game_2Screen";
import { WildFire20_Responsive } from "./slot/WildFire20/game_responsive";
import { WildIcy_1Screen } from "./slot/WildIcy/game_1Screen";
import { MysticKingdom_Responsive } from "./slot/MysticKingdom/game_responsive";
import { MysticRainbow_Responsive } from "./slot/MysticRainbow/game_responsive";
import { MysticRainbowFillingPot_Responsive } from "./slot/MysticRainbowFillingPot/game_responsive";
import { EternalFortuneFillingPot_Responsive } from "./slot/EternalFortuneFillingPot/game_responsive";
import { LavaLandMysticWarriorsFillingPot_Responsive } from "./slot/LavaLandMysticWarriorsFillingPot/game_responsive";
import { MayanHeroesFillingPot_Responsive } from "./slot/MayanHeroesFillingPot/game_responsive";
import { AncientSea3DFillingPot_Responsive } from "./slot/AncientSea3DFillingPot/game_responsive";
import { CloverGirlGreenFillingPot_Responsive } from "./slot/CloverGirlGreenFillingPot/game_responsive";
import { CloverGirlHotFillingPot_Responsive } from "./slot/CloverGirlHotFillingPot/game_responsive";
import { CloverGirlDiamondFillingPot_Responsive } from "./slot/CloverGirlDiamondFillingPot/game_responsive";
import { CloverGirlGoldFillingPot_Responsive } from "./slot/CloverGirlGoldFillingPot/game_responsive";
import { MysticKingdomFillingPot_Responsive } from "./slot/MysticKingdomFillingPot/game_responsive";
import { SpiritsOfTheThunderFillingPot_Responsive } from "./slot/SpiritsOfTheThunderFillingPot/game_responsive";
import { NordicFuryFillingPot_Responsive } from "./slot/NordicFuryFillinPot/game_responsive";
import { GoldAndRumBAFillingPot_Responsive } from "./slot/GoldAndRumBAFillingPot/game_responsive";
import { BambooSecretsFillingPot } from "./slot/BambooSecretsFillingPot/game";
import { BambooSecretsFillingPot2 } from "./slot/BambooSecretsFillingPot/game2";
import { BambooSecretsFillingPot2_2Screen } from "./slot/BambooSecretsFillingPot/game2_2Screen";
import { BambooSecretsFillingPot3 } from "./slot/BambooSecretsFillingPot/game3";
import { BambooSecretsFillingPot_1Screen } from "./slot/BambooSecretsFillingPot/game_1Screen";
import { BambooSecretsFillingPot_2Screen } from "./slot/BambooSecretsFillingPot/game_2Screen";
import { BambooSecretsFillingPot21 } from "./slot/BambooSecretsFillingPot/gameScreenSpecial";
import { GoldAndRumAhoyFillingPot } from "./slot/GoldAndRumAhoyFillingPot/game";
import { GoldAndRumAhoyFillingPot2 } from "./slot/GoldAndRumAhoyFillingPot/game2";
import { GoldAndRumAhoyFillingPot2_2Screen } from "./slot/GoldAndRumAhoyFillingPot/game2_2Screen";
import { GoldAndRumAhoyFillingPot3 } from "./slot/GoldAndRumAhoyFillingPot/game3";
import { GoldAndRumAhoyFillingPot_1Screen } from "./slot/GoldAndRumAhoyFillingPot/game_1Screen";
import { GoldAndRumAhoyFillingPot_2Screen } from "./slot/GoldAndRumAhoyFillingPot/game_2Screen";
import { GoldAndRumAhoyFillingPot21 } from "./slot/GoldAndRumAhoyFillingPot/gameScreenSpecial";
import { GoldAndRumAhoyFillingPot_Responsive } from "./slot/GoldAndRumAhoyFillingPot/game_responsive";
import { BambooSecretsFillingPot_Responsive } from "./slot/BambooSecretsFillingPot/game_responsive";
import { AmazingPanda_ResponsivePIXIApp } from "./slot/AmazingPanda/game_ResponsivePIXIApp";
import { AncientSea_ResponsivePIXIApp } from "./slot/AncientSea/game_ResponsivePIXIApp";
import { BambooSecrets_ResponsivePIXIApp } from "./slot/BambooSecrets/game_ResponsivePIXIApp";
import { AmazingPandaLink_ResponsivePIXIApp } from "./slot/AmazingPandaLink/game_ResponsivePIXIApp";
import { AncientSea3D_ResponsivePIXIApp } from "./slot/AncientSea3D/game_ResponsivePIXIApp";
import { AncientSea3DFillingPot_ResponsivePIXIApp } from "./slot/AncientSea3DFillingPot/game_ResponsivePIXIApp";
import { AncientSeaLink_ResponsivePIXIApp } from "./slot/AncientSeaLink/game_ResponsivePIXIApp";
import { AsianDreams_ResponsivePIXIApp } from "./slot/AsianDreams/game_ResponsivePIXIApp";
import { BambooSecretsFillingPot_ResponsivePIXIApp } from "./slot/BambooSecretsFillingPot/game_ResponsivePIXIApp";
import { BambooSecretsLink_ResponsivePIXIApp } from "./slot/BambooSecretsLink/game_ResponsivePIXIApp";
import { BurningFruits_ResponsivePIXIApp } from "./slot/BurningFruits/game_ResponsivePIXIApp";
import { BurningFruits10_ResponsivePIXIApp } from "./slot/BurningFruits10/game_ResponsivePIXIApp";
import { BurningFruits100_ResponsivePIXIApp } from "./slot/BurningFruits100/game_ResponsivePIXIApp";
import { BurningFruits20_ResponsivePIXIApp } from "./slot/BurningFruits20/game_ResponsivePIXIApp";
import { BurningFruits40_ResponsivePIXIApp } from "./slot/BurningFruits40/game_ResponsivePIXIApp";
import { BurningFruits5_ResponsivePIXIApp } from "./slot/BurningFruits5/game_ResponsivePIXIApp";
import { BurningHot_ResponsivePIXIApp } from "./slot/BurningHot/game_ResponsivePIXIApp";
import { BurningSeven_ResponsivePIXIApp } from "./slot/BurningSeven/game_ResponsivePIXIApp";
import { Catillionare_ResponsivePIXIApp } from "./slot/Catillionare/game_ResponsivePIXIApp";
import { ChilliBlast_ResponsivePIXIApp } from "./slot/ChilliBlast/game_ResponsivePIXIApp";
import { CloverGirlDiamond_ResponsivePIXIApp } from "./slot/CloverGirlDiamond/game_ResponsivePIXIApp";
import { CloverGirlDiamond40_ResponsivePIXIApp } from "./slot/CloverGirlDiamond40/game_ResponsivePIXIApp";
import { CloverGirlDiamondFillingPot_ResponsivePIXIApp } from "./slot/CloverGirlDiamondFillingPot/game_ResponsivePIXIApp";
import { CloverGirlGold_ResponsivePIXIApp } from "./slot/CloverGirlGold/game_ResponsivePIXIApp";
import { CloverGirlGold10_ResponsivePIXIApp } from "./slot/CloverGirlGold10/game_ResponsivePIXIApp";
import { CloverGirlGold10Deluxe_ResponsivePIXIApp } from "./slot/CloverGirlGold10Deluxe/game_ResponsivePIXIApp";
import { CloverGirlGoldFillingPot_ResponsivePIXIApp } from "./slot/CloverGirlGoldFillingPot/game_ResponsivePIXIApp";
import { CloverGirlGreen_ResponsivePIXIApp } from "./slot/CloverGirlGreen/game_ResponsivePIXIApp";
import { CloverGirlGreen20_ResponsivePIXIApp } from "./slot/CloverGirlGreen20/game_ResponsivePIXIApp";
import { CloverGirlGreen20Deluxe_ResponsivePIXIApp } from "./slot/CloverGirlGreen20Deluxe/game_ResponsivePIXIApp";
import { CloverGirlGreenFillingPot_ResponsivePIXIApp } from "./slot/CloverGirlGreenFillingPot/game_ResponsivePIXIApp";
import { CloverGirlHot_ResponsivePIXIApp } from "./slot/CloverGirlHot/game_ResponsivePIXIApp";
import { CloverGirlHot50_ResponsivePIXIApp } from "./slot/CloverGirlHot50/game_ResponsivePIXIApp";
import { CloverGirlHot50Deluxe_ResponsivePIXIApp } from "./slot/CloverGirlHot50Deluxe/game_ResponsivePIXIApp";
import { CloverGirlHotFillingPot_ResponsivePIXIApp } from "./slot/CloverGirlHotFillingPot/game_ResponsivePIXIApp";
import { CrazySeven_ResponsivePIXIApp } from "./slot/CrazySeven/game_ResponsivePIXIApp";
import { EternalFortuneBulk_ResponsivePIXIApp } from "./slot/EternalFortuneBulk/game_ResponsivePIXIApp";
import { EternalFortuneFillingPot_ResponsivePIXIApp } from "./slot/EternalFortuneFillingPot/game_ResponsivePIXIApp";
import { EternalFortuneReel_ResponsivePIXIApp } from "./slot/EternalFortuneReel/game_ResponsivePIXIApp";
import { EternalFortuneStack_ResponsivePIXIApp } from "./slot/EternalFortuneStack/game_ResponsivePIXIApp";
import { FairyMagicForest_ResponsivePIXIApp } from "./slot/FairyMagicForest/game_ResponsivePIXIApp";
import { FairyMagicForestClassic_ResponsivePIXIApp } from "./slot/FairyMagicForestClassic/game_ResponsivePIXIApp";
import { FiestaEnchilada_ResponsivePIXIApp } from "./slot/FiestaEnchilada/game_ResponsivePIXIApp";
import { FireBlast_ResponsivePIXIApp } from "./slot/FireBlast/game_ResponsivePIXIApp";
import { FireBlastClassic_ResponsivePIXIApp } from "./slot/FireBlastClassic/game_ResponsivePIXIApp";
import { FireBlastDeluxClassic_ResponsivePIXIApp } from "./slot/FireBlastDeluxClassic/game_ResponsivePIXIApp";
import { FireFruits_ResponsivePIXIApp } from "./slot/FireFruits/game_ResponsivePIXIApp";
import { FireFruitsLink_ResponsivePIXIApp } from "./slot/FireFruitsLink/game_ResponsivePIXIApp";
import { FireMania_ResponsivePIXIApp } from "./slot/FireMania/game_ResponsivePIXIApp";
import { FreezingFruits_ResponsivePIXIApp } from "./slot/FreezingFruits/game_ResponsivePIXIApp";
import { GoldAndRum_ResponsivePIXIApp } from "./slot/GoldAndRum/game_ResponsivePIXIApp";
import { GoldAndRumAhoyFillingPot_ResponsivePIXIApp } from "./slot/GoldAndRumAhoyFillingPot/game_ResponsivePIXIApp";
import { GoldAndRumBAFillingPot_ResponsivePIXIApp } from "./slot/GoldAndRumBAFillingPot/game_ResponsivePIXIApp";
import { GoldAndRumLink_ResponsivePIXIApp } from "./slot/GoldAndRumLink/game_ResponsivePIXIApp";
import { IceBlast_ResponsivePIXIApp } from "./slot/IceBlast/game_ResponsivePIXIApp";
import { IceBlastDeluxClassic_ResponsivePIXIApp } from "./slot/IceBlastDeluxClassic/game_ResponsivePIXIApp";
import { IcyFresh_ResponsivePIXIApp } from "./slot/IcyFresh/game_ResponsivePIXIApp";
import { IcyFreshLink_ResponsivePIXIApp } from "./slot/IcyFreshLink/game_ResponsivePIXIApp";
import { IcyMania_ResponsivePIXIApp } from "./slot/IcyMania/game_ResponsivePIXIApp";
import { JuicyIce_ResponsivePIXIApp } from "./slot/JuicyIce/game_ResponsivePIXIApp";
import { LavaLand_ResponsivePIXIApp } from "./slot/LavaLand/game_ResponsivePIXIApp";
import { LavaLand2023_ResponsivePIXIApp } from "./slot/LavaLand2023/game_ResponsivePIXIApp";
import { LavaLandLink_ResponsivePIXIApp } from "./slot/LavaLandLink/game_ResponsivePIXIApp";
import { LavaLandMysticWarriors_ResponsivePIXIApp } from "./slot/LavaLandMysticWarriors/game_ResponsivePIXIApp";
import { LavaLandMysticWarriorsFillingPot_ResponsivePIXIApp } from "./slot/LavaLandMysticWarriorsFillingPot/game_ResponsivePIXIApp";
import { LuckyFire_ResponsivePIXIApp } from "./slot/LuckyFire/game_ResponsivePIXIApp";
import { LuckyFire10_ResponsivePIXIApp } from "./slot/LuckyFire10/game_ResponsivePIXIApp";
import { LuckyFire100_ResponsivePIXIApp } from "./slot/LuckyFire100/game_ResponsivePIXIApp";
import { LuckyFire40_ResponsivePIXIApp } from "./slot/LuckyFire40/game_ResponsivePIXIApp";
import { LuckyFire40Delux_ResponsivePIXIApp } from "./slot/LuckyFire40Delux/game_ResponsivePIXIApp";
import { LuckyFire5_ResponsivePIXIApp } from "./slot/LuckyFire5/game_ResponsivePIXIApp";
import { LuckyHot_ResponsivePIXIApp } from "./slot/LuckyHot/game_ResponsivePIXIApp";
import { LuckyIce_ResponsivePIXIApp } from "./slot/LuckyIce/game_ResponsivePIXIApp";
import { LuckyIce10_ResponsivePIXIApp } from "./slot/LuckyIce10/game_ResponsivePIXIApp";
import { LuckyIce100_ResponsivePIXIApp } from "./slot/LuckyIce100/game_ResponsivePIXIApp";
import { LuckyIce20_ResponsivePIXIApp } from "./slot/LuckyIce20/game_ResponsivePIXIApp";
import { LuckyIce40_ResponsivePIXIApp } from "./slot/LuckyIce40/game_ResponsivePIXIApp";
import { LuckyIce40Delux_ResponsivePIXIApp } from "./slot/LuckyIce40Delux/game_ResponsivePIXIApp";
import { LuckyIce5_ResponsivePIXIApp } from "./slot/LuckyIce5/game_ResponsivePIXIApp";
import { LuckySeven_ResponsivePIXIApp } from "./slot/LuckySeven/game_ResponsivePIXIApp";
import { MayanHeroesFillingPot_ResponsivePIXIApp } from "./slot/MayanHeroesFillingPot/game_ResponsivePIXIApp";
import { MayanHeroesLink_ResponsivePIXIApp } from "./slot/MayanHeroesLink/game_ResponsivePIXIApp";
import { MundoMistico_ResponsivePIXIApp } from "./slot/MundoMistico/game_ResponsivePIXIApp";
import { MysticCanyon_ResponsivePIXIApp } from "./slot/MysticCanyon/game_ResponsivePIXIApp";
import { MysticKingdom_ResponsivePIXIApp } from "./slot/MysticKingdom/game_ResponsivePIXIApp";
import { MysticKingdomFillingPot_ResponsivePIXIApp } from "./slot/MysticKingdomFillingPot/game_ResponsivePIXIApp";
import { MysticRainbow_ResponsivePIXIApp } from "./slot/MysticRainbow/game_ResponsivePIXIApp";
import { MysticRainbowFillingPot_ResponsivePIXIApp } from "./slot/MysticRainbowFillingPot/game_ResponsivePIXIApp";
import { PandaBlast_ResponsivePIXIApp } from "./slot/PandaBlast/game_ResponsivePIXIApp";
import { RainbowBlast_ResponsivePIXIApp } from "./slot/RainbowBlast/game_ResponsivePIXIApp";
import { RainbowMagic_ResponsivePIXIApp } from "./slot/RainbowMagic/game_ResponsivePIXIApp";
import { RainbowMagic2023_ResponsivePIXIApp } from "./slot/RainbowMagic2023/game_ResponsivePIXIApp";
import { RainbowMagicClassic_ResponsivePIXIApp } from "./slot/RainbowMagicClassic/game_ResponsivePIXIApp";
import { RainbowTreasure_ResponsivePIXIApp } from "./slot/RainbowTreasure/game_ResponsivePIXIApp";
import { RainbowTreasureLink_ResponsivePIXIApp } from "./slot/RainbowTreasureLink/game_ResponsivePIXIApp";
import { RapidLavaLand_ResponsivePIXIApp } from "./slot/RapidLavaLand/game_ResponsivePIXIApp";
import { RoyalChalice_ResponsivePIXIApp } from "./slot/RoyalChalice/game_ResponsivePIXIApp";
import { RoyalDice_ResponsivePIXIApp } from "./slot/RoyalDice/game_ResponsivePIXIApp";
import { RoyalKing_ResponsivePIXIApp } from "./slot/RoyalKing/game_ResponsivePIXIApp";
import { RoyalKingDeluxe_ResponsivePIXIApp } from "./slot/RoyalKingDeluxe/game_ResponsivePIXIApp";
import { SeaBlast_ResponsivePIXIApp } from "./slot/SeaBlast/game_ResponsivePIXIApp";
import { SecretsOfAnubis_ResponsivePIXIApp } from "./slot/SecretsOfAnubis/game_ResponsivePIXIApp";
import { SecretsOfAnubisClassic_ResponsivePIXIApp } from "./slot/SecretsOfAnubisClassic/game_ResponsivePIXIApp";
import { SecretsOfAnubisLink_ResponsivePIXIApp } from "./slot/SecretsOfAnubisLink/game_ResponsivePIXIApp";
import { SevenBlast_ResponsivePIXIApp } from "./slot/SevenBlast/game_ResponsivePIXIApp";
import { SevenFever_ResponsivePIXIApp } from "./slot/SevenFever/game_ResponsivePIXIApp";
import { SevenFeverClassic_ResponsivePIXIApp } from "./slot/SevenFeverClassic/game_ResponsivePIXIApp";
import { SevenFeverLink_ResponsivePIXIApp } from "./slot/SevenFeverLink/game_ResponsivePIXIApp";
import { SevenMania_ResponsivePIXIApp } from "./slot/SevenMania/game_ResponsivePIXIApp";
import { ShiningChalice_ResponsivePIXIApp } from "./slot/ShiningChalice/game_ResponsivePIXIApp";
import { SpiritOfThunder_ResponsivePIXIApp } from "./slot/SpiritOfThunder/game_ResponsivePIXIApp";
import { SpiritsOfTheThunderFillingPot_ResponsivePIXIApp } from "./slot/SpiritsOfTheThunderFillingPot/game_ResponsivePIXIApp";
import { SpiritsOfTheThunderReloaded_ResponsivePIXIApp } from "./slot/SpiritsOfTheThunderReloaded/game_ResponsivePIXIApp";
import { StickyChilli_ResponsivePIXIApp } from "./slot/StickyChilli/game_ResponsivePIXIApp";
import { StickyChilliClassic_ResponsivePIXIApp } from "./slot/StickyChilliClassic/game_ResponsivePIXIApp";
import { StickyChilliLink_ResponsivePIXIApp } from "./slot/StickyChilliLink/game_ResponsivePIXIApp";
import { SweetBlast_ResponsivePIXIApp } from "./slot/SweetBlast/game_ResponsivePIXIApp";
import { SweetSweet_ResponsivePIXIApp } from "./slot/SweetSweet/game_ResponsivePIXIApp";
import { SweetSweetLink_ResponsivePIXIApp } from "./slot/SweetSweetLink/game_ResponsivePIXIApp";
import { TikiBay_ResponsivePIXIApp } from "./slot/TikiBay/game_ResponsivePIXIApp";
import { TikiBayClassic_ResponsivePIXIApp } from "./slot/TikiBayClassic/game_ResponsivePIXIApp";
import { TikiBayLink_ResponsivePIXIApp } from "./slot/TikiBayLink/game_ResponsivePIXIApp";
import { VintageSevenClassic_ResponsivePIXIApp } from "./slot/VintageSevenClassic/game_ResponsivePIXIApp";
import { Wild7_ResponsivePIXIApp } from "./slot/Wild7/game_ResponsivePIXIApp";
import { WildChalice_ResponsivePIXIApp } from "./slot/WildChalice/game_ResponsivePIXIApp";
import { WildChilli_ResponsivePIXIApp } from "./slot/WildChilli/game_ResponsivePIXIApp";
import { WildFire_ResponsivePIXIApp } from "./slot/WildFire/game_ResponsivePIXIApp";
import { WildFire100_ResponsivePIXIApp } from "./slot/WildFire100/game_ResponsivePIXIApp";
import { WildFire20_ResponsivePIXIApp } from "./slot/WildFire20/game_ResponsivePIXIApp";
import { WildIcy_ResponsivePIXIApp } from "./slot/WildIcy/game_ResponsivePIXIApp";
import { MayanHeroes_ResponsivePIXIApp } from "./slot/MayanHeroes/game_ResponsivePIXIApp";
import { IcyManiaDeluxClassic_ResponsivePIXIApp } from "./slot/IcyManiaDeluxClassic/game_ResponsivePIXIApp";
import { LuckyFire20_ResponsivePIXIApp } from "./slot/LuckyFire 20/game_responsivePIXIApp";
import { VintageSeven_ResponsivePIXIApp } from "./slot/VintageSeven/game_responsivePIXIApp";
import { NordicFuryFillingPot_ResponsivePIXIApp } from "./slot/NordicFuryFillinPot/game_responsivePIXIApp";
import { NordicFuryMB } from "./slot/NordicFuryMB/game";
import { NordicFuryMB2 } from "./slot/NordicFuryMB/game2";
import { NordicFuryMB2_2Screen } from "./slot/NordicFuryMB/game2_2Screen";
import { NordicFuryMB3 } from "./slot/NordicFuryMB/game3";
import { NordicFuryMB_1Screen } from "./slot/NordicFuryMB/game_1Screen";
import { NordicFuryMB_2Screen } from "./slot/NordicFuryMB/game_2Screen";
import { NordicFuryMB21 } from "./slot/NordicFuryMB/gameScreenSpecial";
import { NordicFuryFillingMB_ResponsivePIXIApp } from "./slot/NordicFuryMB/game_ResponsivePIXIApp";
import { NordicFuryMB_Responsive } from "./slot/NordicFuryMB/game_Responsive";
import { BambooSecretsMB_1Screen } from "./slot/BambooSecretsMB/game_1Screen";
import { BambooSecretsMB } from "./slot/BambooSecretsMB/game";
import { BambooSecretsMB2 } from "./slot/BambooSecretsMB/game2";
import { BambooSecretsMB2_2Screen } from "./slot/BambooSecretsMB/game2_2Screen";
import { BambooSecretsMB3 } from "./slot/BambooSecretsMB/game3";
import { BambooSecretsMB_2Screen } from "./slot/BambooSecretsMB/game_2Screen";
import { BambooSecretsMB21 } from "./slot/BambooSecretsMB/gameScreenSpecial";
import { SecretsOfAnubisMB } from "./slot/SecretsOfAnubisMB/game";
import { SecretsOfAnubisMB2 } from "./slot/SecretsOfAnubisMB/game2";
import { SecretsOfAnubisMB2_2Screen } from "./slot/SecretsOfAnubisMB/game2_2Screen";
import { SecretsOfAnubisMB3 } from "./slot/SecretsOfAnubisMB/game3";
import { SecretsOfAnubisMB_1Screen } from "./slot/SecretsOfAnubisMB/game_1Screen";
import { SecretsOfAnubisMB_2Screen } from "./slot/SecretsOfAnubisMB/game_2Screen";
import { SecretsOfAnubisMB21 } from "./slot/SecretsOfAnubisMB/gameScreenSpecial";
import { SecretsOfAnubisMB_ResponsivePIXIApp } from "./slot/SecretsOfAnubisMB/game_ResponsivePIXIApp";
import { LavaLandMysticWarriorsMB } from "./slot/LavaLandMysticWarriorsMB/game";
import { LavaLandMysticWarriorsMB2 } from "./slot/LavaLandMysticWarriorsMB/game2";
import { LavaLandMysticWarriorsMB2_2Screen } from "./slot/LavaLandMysticWarriorsMB/game2_2Screen";
import { LavaLandMysticWarriorsMB3 } from "./slot/LavaLandMysticWarriorsMB/game3";
import { LavaLandMysticWarriorsMB_1Screen } from "./slot/LavaLandMysticWarriorsMB/game_1Screen";
import { LavaLandMysticWarriorsMB_2Screen } from "./slot/LavaLandMysticWarriorsMB/game_2Screen";
import { LavaLandMysticWarriorsMB21 } from "./slot/LavaLandMysticWarriorsMB/gameScreenSpecial";
import { LavaLandMysticWarriorsMB_ResponsivePIXIApp } from "./slot/LavaLandMysticWarriorsMB/game_ResponsivePIXIApp";
import { CloverGirlGreenFillingPotMB } from "./slot/CloverGirlGreenFillingPotMB/game";
import { CloverGirlGreenFillingPotMB2 } from "./slot/CloverGirlGreenFillingPotMB/game2";
import { CloverGirlGreenFillingPotMB2_2Screen } from "./slot/CloverGirlGreenFillingPotMB/game2_2Screen";
import { CloverGirlGreenFillingPotMB3 } from "./slot/CloverGirlGreenFillingPotMB/game3";
import { CloverGirlGreenFillingPotMB_1Screen } from "./slot/CloverGirlGreenFillingPotMB/game_1Screen";
import { CloverGirlGreenFillingPotMB_2Screen } from "./slot/CloverGirlGreenFillingPotMB/game_2Screen";
import { CloverGirlGreenFillingPotMB21 } from "./slot/CloverGirlGreenFillingPotMB/gameScreenSpecial";
import { LavaLandMysticWarriorsMB_Responsive } from "./slot/LavaLandMysticWarriorsMB/game_responsive";
import { BambooSecretsMB_Responsive } from "./slot/BambooSecretsMB/game_responsive";
import { GenericGame1 } from "./slot/Generic/GenericGame1";
import { GenericGame3 } from "./slot/Generic/GenericGame3";
import { GenericGame2 } from "./slot/Generic/GenericGame2";
import { GenericGame21 } from "./slot/Generic/GenericGame21";
import { Generic_Responsive } from "./slot/Generic/Generic_Responsive";
import { Generic_ResponsivePIXIApp } from "./slot/Generic/Generic_ResponsivePIXIApp";
import { CloverGirlGreen10_Responsive } from "./slot/CloverGirlGreen10/game_responsive";
import { CloverGirlGreen10_ResponsivePIXIApp } from "./slot/CloverGirlGreen10/game_ResponsivePIXIApp";
import { CloverGirlGreen40_Responsive } from "./slot/CloverGirlGreen40/game_responsive";
import { CloverGirlGreen40_ResponsivePIXIApp } from "./slot/CloverGirlGreen40/game_ResponsivePIXIApp";
import { FireBlastClassic10_1Screen } from "./slot/FireBlastClassic10/game_1Screen";
import { FireBlastClassic10_ResponsivePIXIApp } from "./slot/FireBlastClassic10/game_ResponsivePIXIApp";
import { FireBlastClassic10_Responsive } from "./slot/FireBlastClassic10/game_responsive";
import { LuckySeven5_1Screen } from "./slot/LuckySeven5/game_1Screen";
import { LuckySeven5_Responsive } from "./slot/LuckySeven5/game_responsive";
import { LuckySeven5_ResponsivePIXIApp } from "./slot/LuckySeven5/game_ResponsivePIXIApp";
import { RoyalChalice10_1Screen } from "./slot/RoyalChalice10/game_1Screen";
import { RoyalChalice10_Responsive } from "./slot/RoyalChalice10/game_responsive";
import { RoyalChalice10_ResponsivePIXIApp } from "./slot/RoyalChalice10/game_ResponsivePIXIApp";
import { RoyalChalice20_1Screen } from "./slot/RoyalChalice20/game_1Screen";
import { RoyalChalice20_Responsive } from "./slot/RoyalChalice20/game_responsive";
import { RoyalChalice20_ResponsivePIXIApp } from "./slot/RoyalChalice20/game_ResponsivePIXIApp";
import { RoyalChalice40_1Screen } from "./slot/RoyalChalice40/game_1Screen";
import { RoyalChalice40_Responsive } from "./slot/RoyalChalice40/game_responsive";
import { RoyalChalice40_ResponsivePIXIApp } from "./slot/RoyalChalice40/game_ResponsivePIXIApp";
import { RoyalDice10_1Screen } from "./slot/RoyalDice10/game_1Screen";
import { RoyalDice10_Responsive } from "./slot/RoyalDice10/game_responsive";
import { RoyalDice10_ResponsivePIXIApp } from "./slot/RoyalDice10/game_ResponsivePIXIApp";
import { RoyalDice20_1Screen } from "./slot/RoyalDice20/game_1Screen";
import { RoyalDice20_Responsive } from "./slot/RoyalDice20/game_responsive";
import { RoyalDice20_ResponsivePIXIApp } from "./slot/RoyalDice20/game_ResponsivePIXIApp";
import { RoyalKing10_1Screen } from "./slot/RoyalKing10/game_1Screen";
import { RoyalKing10_Responsive } from "./slot/RoyalKing10/game_responsive";
import { RoyalKing10_ResponsivePIXIApp } from "./slot/RoyalKing10/game_ResponsivePIXIApp";
import { RoyalKing20_1Screen } from "./slot/RoyalKing20/game_1Screen";
import { RoyalKing20_Responsive } from "./slot/RoyalKing20/game_responsive";
import { RoyalKing20_ResponsivePIXIApp } from "./slot/RoyalKing20/game_ResponsivePIXIApp";
import { RoyalKing40_1Screen } from "./slot/RoyalKing40/game_1Screen";
import { RoyalKing40_Responsive } from "./slot/RoyalKing40/game_responsive";
import { RoyalKing40_ResponsivePIXIApp } from "./slot/RoyalKing40/game_ResponsivePIXIApp";
import { RoyalKingDeluxe10_1Screen } from "./slot/RoyalKingDeluxe10/game_1Screen";
import { RoyalKingDeluxe10_Responsive } from "./slot/RoyalKingDeluxe10/game_responsive";
import { RoyalKingDeluxe10_ResponsivePIXIApp } from "./slot/RoyalKingDeluxe10/game_ResponsivePIXIApp";
import { LuckyFire50Delux_Responsive } from "./slot/LuckyFire50Delux/game_responsive";
import { LuckyFire50Delux_ResponsivePIXIApp } from "./slot/LuckyFire50Delux/game_ResponsivePIXIApp";
import { LuckyFire100Delux_Responsive } from "./slot/LuckyFire100Delux/game_responsive";
import { LuckyFire100Delux_ResponsivePIXIApp } from "./slot/LuckyFire100Delux/game_ResponsivePIXIApp";
import { RoyalDice5_Responsive } from "./slot/RoyalDice5/game_responsive";
import { RoyalDice5_ResponsivePIXIApp } from "./slot/RoyalDice5/game_ResponsivePIXIApp";
import { RoyalDice20Delux_Responsive } from "./slot/RoyalDice20Delux/game_responsive";
import { RoyalDice20Delux_ResponsivePIXIApp } from "./slot/RoyalDice20Delux/game_ResponsivePIXIApp";
import { RoyalDice40Delux_Responsive } from "./slot/RoyalDice40Delux/game_responsive";
import { RoyalDice40Delux_ResponsivePIXIApp } from "./slot/RoyalDice40Delux/game_ResponsivePIXIApp";
import { RoyalDice40_Responsive } from "./slot/RoyalDice40/game_responsive";
import { RoyalDice40_ResponsivePIXIApp } from "./slot/RoyalDice40/game_ResponsivePIXIApp";
import { RoyalKing5_Responsive } from "./slot/RoyalKing5/game_responsive";
import { RoyalKing5_ResponsivePIXIApp } from "./slot/RoyalKing5/game_ResponsivePIXIApp";
import { RoyalKingDeluxe20_Responsive } from "./slot/RoyalKingDeluxe20/game_responsive";
import { RoyalKingDeluxe20_ResponsivePIXIApp } from "./slot/RoyalKingDeluxe20/game_ResponsivePIXIApp";
import { RoyalKingDeluxe40_Responsive } from "./slot/RoyalKingDeluxe40/game_responsive";
import { RoyalKingDeluxe40_ResponsivePIXIApp } from "./slot/RoyalKingDeluxe40/game_ResponsivePIXIApp";
import { WildChalice40Delux_Responsive } from "./slot/WildChalice40Delux/game_responsive";
import { WildChalice40Delux_ResponsivePIXIApp } from "./slot/WildChalice40Delux/game_ResponsivePIXIApp";
import { WildChalice20_Responsive } from "./slot/WildChalice20/game_responsive";
import { WildChalice20_ResponsivePIXIApp } from "./slot/WildChalice20/game_ResponsivePIXIApp";
export interface IGameFactory {
    CreateGame_1_1s(multigameParams: MultigameParams, initData: SlotGameInitData): SlotGame;
    CreateGame_Responsive(multigameParams: MultigameParams, initData: SlotGameInitData): SlotGame;
    CreateGame_ResponsivePIXIAPP(multigameParams: MultigameParams, initData: SlotGameInitData): SlotGame;

    CreateGame_1_2s(multigameParams: MultigameParams, initData: SlotGameInitData): SlotGame;
    CreateGame_2_2s(multigameParams: MultigameParams2, initData: SlotGameInitData): SlotGame2;

    CreateGame_1_3s(multigameParams: MultigameParams, initData: SlotGameInitData): SlotGame;
    CreateGame_2_3s(multigameParams: MultigameParams2, initData: SlotGameInitData): SlotGame2;
    CreateGame_3_3s(multigameParams: MultigameParams3, initData: SlotGameInitData): SlotGame3;
    CreateGame_PixiAPP(multigameParams: MultigameParams, initData: SlotGameInitData): SlotGame;
    CreateGame21(multigameParams: MultigameParams21, initData: SlotGameInitData): SlotGame21;
}


export class CreateGameFactory {

    public static readonly Instance: CreateGameFactory = new CreateGameFactory();
    protected constructor() { }

    protected registeredGames: { [key: string]: IGameFactory } = {
        "AmazingPanda": {
            CreateGame_1_1s: (multigameParams, initData) => new AmazingPanda_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AmazingPanda_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AmazingPanda_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new AmazingPanda_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new AmazingPanda2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new AmazingPanda(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new AmazingPanda2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new AmazingPanda3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new AmazingPanda21(multigameParams, initData)

        },
        "AncientSea": {
            CreateGame_1_1s: (multigameParams, initData) => new AncientSea_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AncientSea_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AncientSea_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new AncientSea_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new AncientSea2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new AncientSea(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new AncientSea2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new AncientSea3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new AncientSea21(multigameParams, initData)
        },
        "AncientSea3DClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new AncientSea3DClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AncientSea3DClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AncientSea_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new AncientSea3DClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new AncientSea3DClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new AncientSea3DClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new AncientSea3DClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new AncientSea3DClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new AncientSea3DClassic21(multigameParams, initData)
        },
        "BambooSecrets": {
            CreateGame_1_1s: (multigameParams, initData) => new BambooSecrets_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BambooSecrets_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BambooSecrets_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new BambooSecrets_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BambooSecrets2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BambooSecrets(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BambooSecrets2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BambooSecrets3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BambooSecrets21(multigameParams, initData),
        },
        "FiestaEnchilada": {
            CreateGame_1_1s: (multigameParams, initData) => new FiestaEnchilada_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FiestaEnchilada_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FiestaEnchilada_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new FiestaEnchilada_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new FiestaEnchilada2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new FiestaEnchilada(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new FiestaEnchilada2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new FiestaEnchilada3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new FiestaEnchilada21(multigameParams, initData),
        },
        "FireFruits": {
            CreateGame_1_1s: (multigameParams, initData) => new FireFruits_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireFruits_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireFruits_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new FireFruits_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new FireFruits2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new FireFruits(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new FireFruits2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new FireFruits3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new FireFruits21(multigameParams, initData),
        },
        "GoldAndRum": {
            CreateGame_1_1s: (multigameParams, initData) => new GoldAndRum_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new GoldAndRum_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new GoldAndRum_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new GoldAndRum_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new GoldAndRum2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new GoldAndRum(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new GoldAndRum2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GoldAndRum3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new GoldAndRum21(multigameParams, initData),
        },
        "RumAndGold": {
            CreateGame_1_1s: (multigameParams, initData) => new GoldAndRum_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new GoldAndRum_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new GoldAndRum_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new GoldAndRum_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new GoldAndRum2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new GoldAndRum(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new GoldAndRum2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GoldAndRum3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new GoldAndRum21(multigameParams, initData),
        },
        "IcyFresh": {
            CreateGame_1_1s: (multigameParams, initData) => new IcyFresh_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new IcyFresh_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new IcyFresh_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new IcyFresh_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new IcyFresh2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new IcyFresh(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new IcyFresh2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new IcyFresh3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new IcyFresh21(multigameParams, initData),

        },
        "JuicyIce": {
            CreateGame_1_1s: (multigameParams, initData) => new JuicyIce_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new JuicyIce_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new JuicyIce_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new JuicyIce_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new JuicyIce2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new JuicyIce(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new JuicyIce2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new JuicyIce3(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new JuicyIce21(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null
        },
        "LavaLand": {
            CreateGame_1_1s: (multigameParams, initData) => new LavaLand_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LavaLand_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LavaLand_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LavaLand_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LavaLand2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LavaLand(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LavaLand2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LavaLand3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LavaLand21(multigameParams, initData),
        },
        "LavaLandMysticWarriors": {
            CreateGame_1_1s: (multigameParams, initData) => new LavaLandMysticWarriors_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LavaLandMysticWarriors_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LavaLandMysticWarriors_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LavaLandMysticWarriors_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LavaLandMysticWarriors2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LavaLandMysticWarriors(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LavaLandMysticWarriors2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LavaLandMysticWarriors3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LavaLandMysticWarriors21(multigameParams, initData),

        },
        "MayanHeroes": {
            CreateGame_1_1s: (multigameParams, initData) => new MayanHeroes_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MayanHeroes_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MayanHeroes_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new MayanHeroes_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MayanHeroes2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MayanHeroes(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MayanHeroes2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MayanHeroes3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new MayanHeroes21(multigameParams, initData),

        },
        "PandaQuest": {
            CreateGame_1_1s: (multigameParams, initData) => new PandaQuest_2Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => { throw new Error("CreateGame_Responsive not implemented for PandaQuest"); },
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => { throw new Error("CreateGame_Responsive not implemented for PandaQuest"); },


            CreateGame_1_2s: (multigameParams, initData) => new PandaQuest_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new PandaQuest2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new PandaQuest(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new PandaQuest2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new PandaQuest3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new PandaQuest21(multigameParams, initData),

        },
        "RainbowMagic": {
            CreateGame_1_1s: (multigameParams, initData) => new RainbowMagic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RainbowMagic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RainbowMagic_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new RainbowMagic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RainbowMagic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RainbowMagic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RainbowMagic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RainbowMagic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RainbowMagic21(multigameParams, initData),

        },
        "RainbowTreasure": {
            CreateGame_1_1s: (multigameParams, initData) => new RainbowTreasure_2Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RainbowTreasure_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RainbowTreasure_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new RainbowTreasure_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RainbowTreasure2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RainbowTreasure(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RainbowTreasure2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RainbowTreasure3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RainbowTreasure21(multigameParams, initData),

        },
        "SecretsOfAnubis": {
            CreateGame_1_1s: (multigameParams, initData) => new SecretsOfAnubis_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SecretsOfAnubis_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SecretsOfAnubis_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new SecretsOfAnubis_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SecretsOfAnubis2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SecretsOfAnubis(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SecretsOfAnubis2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SecretsOfAnubis3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SecretsOfAnubis21(multigameParams, initData),

        },
        "SevenFever": {
            CreateGame_1_1s: (multigameParams, initData) => new SevenFever_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SevenFever_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SevenFever_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new SevenFever_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SevenFever2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SevenFever(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SevenFever2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SevenFever3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SevenFever21(multigameParams, initData),

        },
        "SevenForever": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game SevenForever not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => { throw new Error("CreateGame_Responsive not implemented for seven forever"); },
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => { throw new Error("CreateGame_Responsive not implemented for seven forever"); },


            CreateGame_1_2s: (multigameParams, initData) => new SevenForever_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SevenForever2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SevenForever(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SevenForever2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SevenForever3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SevenForever21(multigameParams, initData),

        },
        "SpiritOfThunder": {
            CreateGame_1_1s: (multigameParams, initData) => new SpiritOfThunder_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SpiritOfThunder_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SpiritOfThunder_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new SpiritOfThunder_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SpiritOfThunder2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SpiritOfThunder(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SpiritOfThunder2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SpiritOfThunder3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SpiritOfThunder21(multigameParams, initData),

        },
        "StickyChilli": {
            CreateGame_1_1s: (multigameParams, initData) => new StickyChilli_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new StickyChilli_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new StickyChilli_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new StickyChilli_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new StickyChilli2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new StickyChilli(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new StickyChilli2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new StickyChilli3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new StickyChilli21(multigameParams, initData),

        },
        "StickyChilliClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new StickyChilliClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new StickyChilliClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new StickyChilliClassic_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new StickyChilliClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new StickyChilliClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new StickyChilliClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new StickyChilliClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new StickyChilliClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new StickyChilliClassic21(multigameParams, initData),

        },
        "SweetSweet": {
            CreateGame_1_1s: (multigameParams, initData) => new SweetSweet_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SweetSweet_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SweetSweet_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new SweetSweet_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SweetSweet2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SweetSweet(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SweetSweet2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SweetSweet3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SweetSweet21(multigameParams, initData),

        },
        "TikiBay": {
            CreateGame_1_1s: (multigameParams, initData) => new TikiBay_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new TikiBay_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new TikiBay_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new TikiBay_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new TikiBay2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new TikiBay(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new TikiBay2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new TikiBay3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new TikiBay21(multigameParams, initData),

        },
        "JubileeSevenFever": {
            CreateGame_1_1s: (multigameParams, initData) => new JubileeSevenFever_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "JubileeSevenFever"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "JubileeSevenFever"),

            CreateGame_1_2s: (multigameParams, initData) => new JubileeSevenFever_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new JubileeSevenFever2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new JubileeSevenFever(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new JubileeSevenFever2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new JubileeSevenFever3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new JubileeSevenFever21(multigameParams, initData),

        },
        "Catillionare": {
            CreateGame_1_1s: (multigameParams, initData) => new Catillionare_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new Catillionare_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Catillionare_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new Catillionare_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new Catillionare2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new Catillionare(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new Catillionare2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new Catillionare3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new Catillionare21(multigameParams, initData),

        },
        "FairyMagicForest": {
            CreateGame_1_1s: (multigameParams, initData) => new FairyMagicForest_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FairyMagicForest_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FairyMagicForest_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new FairyMagicForest_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new FairyMagicForest2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new FairyMagicForest(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new FairyMagicForest2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new FairyMagicForest3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new FairyMagicForest21(multigameParams, initData),

        },
        "BurningSeven": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningSeven_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningSeven_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningSeven_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new BurningSeven_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningSeven2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningSeven(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningSeven2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningSeven3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningSeven21(multigameParams, initData),

        },
        "IcyMania": {
            CreateGame_1_1s: (multigameParams, initData) => new IcyMania_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new IcyMania_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new IcyMania_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new IcyMania_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new IcyMania2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new IcyMania(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new IcyMania2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new IcyMania3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new IcyMania21(multigameParams, initData),

        },
        "IcyManiaDeluxClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new IcyManiaDeluxClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new IcyManiaDeluxClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new IcyManiaDeluxClassic_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new IcyManiaDeluxClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new IcyManiaDeluxClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new IcyManiaDeluxClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new IcyManiaDeluxClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new IcyManiaDeluxClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new IcyManiaDeluxClassic21(multigameParams, initData),

        },
        "FireMania": {
            CreateGame_1_1s: (multigameParams, initData) => new FireMania_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireMania_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireMania_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game FireMania not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game FireMania not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game FireMania not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game FireMania not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game FireMania not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "WildFire": {
            CreateGame_1_1s: (multigameParams, initData) => new WildFire_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new WildFire_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildFire_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildFire not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildFire not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildFire not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildFire not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildFire not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "WildIcy": {
            CreateGame_1_1s: (multigameParams, initData) => new WildIcy_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => { throw new Error("CreateGame_Responsive not implemented for WildIcy"); },
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildIcy_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildIcy not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildIcy not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildIcy not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildIcy not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildIcy not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "Wild7": {
            CreateGame_1_1s: (multigameParams, initData) => new Wild7_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new Wild7_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Wild7_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game Wild7 not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game Wild7 not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game Wild7 not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game Wild7 not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game Wild7 not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "SevenMania": {
            CreateGame_1_1s: (multigameParams, initData) => new SevenMania_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SevenMania_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SevenMania_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SevenMania not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SevenMania not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SevenMania not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SevenMania not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SevenMania not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenMania not implemented" },

        },
        "FireBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new FireBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireBlast_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game FireBlast not implemented" },

        },
          "FireBlastClassic10": {
            CreateGame_1_1s: (multigameParams, initData) => new FireBlastClassic10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireBlastClassic10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireBlastClassic10_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game FireBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game FireBlast not implemented" },

        },
        "FireBlastClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new FireBlastClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireBlastClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireBlastClassic_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new FireBlastClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new FireBlastClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new FireBlastClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new FireBlastClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new FireBlastClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new FireBlastClassic21(multigameParams, initData),

        },
        "SevenBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new SevenBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SevenBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SevenBlast_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "IceBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new IceBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new IceBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new IceBlast_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new IceBlast_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new IceBlast2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new IceBlast(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new IceBlast2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new IceBlast3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new IceBlast21(multigameParams, initData),

        },
        "BurningFruits": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningFruits_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningFruits_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningFruits_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new BurningFruits_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningFruits2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningFruits(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningFruits2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningFruits3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningFruits21(multigameParams, initData),

        },
        "BurningFruits10": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningFruits10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningFruits10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningFruits10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new BurningFruits10_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningFruits10_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningFruits10(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningFruits10_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningFruits10_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningFruits1021(multigameParams, initData),

        },
        "BurningFruits20": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningFruits20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningFruits20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningFruits20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new BurningFruits20_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningFruits20_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningFruits20(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningFruits20_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningFruits20_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningFruits2021(multigameParams, initData),

        },
        "BurningFruits40": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningFruits40_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningFruits40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningFruits40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new BurningFruits40_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningFruits40_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningFruits40(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningFruits40_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningFruits40_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningFruits4021(multigameParams, initData),

        },
        "BurningFruits100": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningFruits100_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningFruits100_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningFruits100_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new BurningFruits100_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningFruits100_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningFruits100(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningFruits100_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningFruits100_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningFruits10021(multigameParams, initData),

        },
        "BurningFruits5": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningFruits5_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningFruits5_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningFruits5_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "FreezingFruits": {
            CreateGame_1_1s: (multigameParams, initData) => new FreezingFruits_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FreezingFruits_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FreezingFruits_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game FreezingFruits not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game FreezingFruits not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game FreezingFruits not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game FreezingFruits not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game FreezingFruits not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game SevenBlast not implemented" },

        },
        "LuckyFire": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire21(multigameParams, initData),

        },
        "LuckyFire20": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire20_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire20_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire20(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire20_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire20_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire2021(multigameParams, initData),

        },
        "LuckyFire40": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire40_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire40_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire40_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire40(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire40_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire40_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire4021(multigameParams, initData),

        },
        "LuckyFire100": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire100_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire100_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire100_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire100_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire100_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire100(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire100_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire100_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire10021(multigameParams, initData),

        },
        "CrazySeven": {
            CreateGame_1_1s: (multigameParams, initData) => new CrazySeven_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new CrazySeven_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CrazySeven_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new CrazySeven_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new CrazySeven2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new CrazySeven(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new CrazySeven2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new CrazySeven3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new CrazySeven21(multigameParams, initData),

        },
        "LuckyIce": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce21(multigameParams, initData),

        },
        "LuckyIce20": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce20_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce20_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce20(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce20_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce20_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce2021(multigameParams, initData),

        },
        "LuckyIce40": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce40_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce40_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce40_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce40(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce40_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce40_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce4021(multigameParams, initData),

        },
        "LuckyIce100": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce100_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce100_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce100_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce100_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce100_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce100(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce100_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce100_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce10021(multigameParams, initData),

        },
        "LuckySeven": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckySeven_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckySeven_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckySeven_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckySeven_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckySeven2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckySeven(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckySeven2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckySeven3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckySeven21(multigameParams, initData),

        },
        "WildChilli": {
            CreateGame_1_1s: (multigameParams, initData) => new WildChilli_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new WildChilli_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildChilli_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
          "LuckySeven5": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckySeven5_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckySeven5_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckySeven5_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
         "RoyalChalice10": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalChalice10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalChalice10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalChalice10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
          "RoyalChalice20": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalChalice20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalChalice20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalChalice20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
         "RoyalChalice40": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalChalice40_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalChalice40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalChalice40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "RoyalDice10": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalDice10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
         "RoyalDice20": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalDice20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
            "RoyalKing10": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalKing10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKing10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKing10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
         "RoyalKing20": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalKing20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKing20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKing20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
         "RoyalKing40": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalKing40_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKing40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKing40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
         "RoyalKingDeluxe10": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalKingDeluxe10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKingDeluxe10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKingDeluxe10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game WildChilli not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "ChilliBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new ChilliBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new ChilliBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new ChilliBlast_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new ChilliBlast_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new ChilliBlast2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new ChilliBlast(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new ChilliBlast2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new ChilliBlast3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new ChilliBlast21(multigameParams, initData),

        },
        "SeaBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new SeaBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SeaBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SeaBlast_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SeaBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SeaBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SeaBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SeaBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SeaBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "PandaBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new PandaBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new PandaBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new PandaBlast_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game PandaBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game PandaBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game PandaBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game PandaBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game PandaBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "SweetBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new SweetBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SweetBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SweetBlast_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new SweetBlast_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SweetBlast2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SweetBlast(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SweetBlast2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SweetBlast3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SweetBlast21(multigameParams, initData),

        },
        "RainbowBlast": {
            CreateGame_1_1s: (multigameParams, initData) => new RainbowBlast_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RainbowBlast_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RainbowBlast_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game RainbowBlast not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game RainbowBlast not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game RainbowBlast not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game RainbowBlast not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game RainbowBlast not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "GoldAndRumLink": {
            CreateGame_1_1s: (multigameParams, initData) => new GoldAndRumLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new GoldAndRumLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new GoldAndRumLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "RumAndGoldLink": {
            CreateGame_1_1s: (multigameParams, initData) => new GoldAndRumLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new GoldAndRumLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new GoldAndRumLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game GoldAndRumLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "SweetSweetLink": {
            CreateGame_1_1s: (multigameParams, initData) => new SweetSweetLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SweetSweetLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SweetSweetLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SweetSweetLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SweetSweetLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SweetSweetLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SweetSweetLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SweetSweetLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "LavaLandLink": {
            CreateGame_1_1s: (multigameParams, initData) => new LavaLandLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LavaLandLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LavaLandLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game LavaLandLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game LavaLandLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game LavaLandLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game LavaLandLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game LavaLandLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "SecretsOfAnubisLink": {
            CreateGame_1_1s: (multigameParams, initData) => new SecretsOfAnubisLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SecretsOfAnubisLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SecretsOfAnubisLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SecretsOfAnubisLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SecretsOfAnubisLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SecretsOfAnubisLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SecretsOfAnubisLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SecretsOfAnubisLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "TikiBayLink": {
            CreateGame_1_1s: (multigameParams, initData) => new TikiBayLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new TikiBayLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new TikiBayLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game TikiBayLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game TikiBayLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game TikiBayLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game TikiBayLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game TikiBayLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "MayanHeroesLink": {
            CreateGame_1_1s: (multigameParams, initData) => new MayanHeroesLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MayanHeroesLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MayanHeroesLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game MayanHeroesLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game MayanHeroesLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game MayanHeroesLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game MayanHeroesLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game MayanHeroesLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "SevenFeverLink": {
            CreateGame_1_1s: (multigameParams, initData) => new SevenFeverLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SevenFeverLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SevenFeverLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SevenFeverLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SevenFeverLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game SevenFeverLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game SevenFeverLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game SevenFeverLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "RainbowTreasureLink": {
            CreateGame_1_1s: (multigameParams, initData) => new RainbowTreasureLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RainbowTreasureLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RainbowTreasureLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game RainbowTreasureLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game RainbowTreasureLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game RainbowTreasureLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game RainbowTreasureLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game RainbowTreasureLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "BambooSecretsLink": {
            CreateGame_1_1s: (multigameParams, initData) => new BambooSecretsLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BambooSecretsLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BambooSecretsLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game BambooSecretsLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game BambooSecretsLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game BambooSecretsLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game BambooSecretsLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game BambooSecretsLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "FireFruitsLink": {
            CreateGame_1_1s: (multigameParams, initData) => new FireFruitsLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireFruitsLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireFruitsLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game FireFruitsLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game FireFruitsLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game FireFruitsLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game FireFruitsLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game FireFruitsLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "IcyFreshLink": {
            CreateGame_1_1s: (multigameParams, initData) => new IcyFreshLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new IcyFreshLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new IcyFreshLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game IcyFreshLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game IcyFreshLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game IcyFreshLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game IcyFreshLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game IcyFreshLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "AncientSeaLink": {
            CreateGame_1_1s: (multigameParams, initData) => new AncientSeaLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AncientSeaLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AncientSeaLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game AncientSeaLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game AncientSeaLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game AncientSeaLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game AncientSeaLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game AncientSeaLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "AmazingPandaLink": {
            CreateGame_1_1s: (multigameParams, initData) => new AmazingPandaLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AmazingPandaLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AmazingPandaLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game AmazingPandaLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game AmazingPandaLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game AmazingPandaLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game AmazingPandaLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game AmazingPandaLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "StickyChilliLink": {
            CreateGame_1_1s: (multigameParams, initData) => new StickyChilliLink_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new StickyChilliLink_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new StickyChilliLink_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game StickyChilliLink not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game StickyChilliLink not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => { throw "Game StickyChilliLink not implemented" },
            CreateGame_2_3s: (multigameParams, initData) => { throw "Game StickyChilliLink not implemented" },
            CreateGame_3_3s: (multigameParams, initData) => { throw "Game StickyChilliLink not implemented" },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw "Game WildChilli not implemented" },

        },
        "RapidLavaLand": {
            CreateGame_1_1s: (multigameParams, initData) => new RapidLavaLand_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RapidLavaLand_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RapidLavaLand_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RapidLavaLand_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RapidLavaLand2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RapidLavaLand(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RapidLavaLand2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RapidLavaLand3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RapidLavaLand21(multigameParams, initData),

        },
        "LuckyHot": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyHot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyHot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyHot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyHot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyHot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyHot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyHot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyHot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyHot21(multigameParams, initData),

        },
        "BurningHot": {
            CreateGame_1_1s: (multigameParams, initData) => new BurningHot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BurningHot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BurningHot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new BurningHot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BurningHot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BurningHot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BurningHot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BurningHot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new BurningHot21(multigameParams, initData),

        },
        "ShiningChalice": {
            CreateGame_1_1s: (multigameParams, initData) => new ShiningChalice_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new ShiningChalice_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new ShiningChalice_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new ShiningChalice_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new ShiningChalice2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new ShiningChalice(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new ShiningChalice2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new ShiningChalice3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new ShiningChalice21(multigameParams, initData),

        },
        "EternalFortuneBulk": {
            CreateGame_1_1s: (multigameParams, initData) => new EternalFortuneBulk_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new EternalFortuneBulk_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new EternalFortuneBulk_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new EternalFortuneBulk_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new EternalFortuneBulk2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new EternalFortuneBulk(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new EternalFortuneBulk2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new EternalFortuneBulk3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new EternalFortuneBulk21(multigameParams, initData),

        },
        "EternalFortuneReel": {
            CreateGame_1_1s: (multigameParams, initData) => new EternalFortuneReel_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new EternalFortuneReel_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new EternalFortuneReel_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new EternalFortuneReel_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new EternalFortuneReel2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new EternalFortuneReel(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new EternalFortuneReel2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new EternalFortuneReel3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new EternalFortuneReel21(multigameParams, initData),

        },
        "EternalFortuneStack": {
            CreateGame_1_1s: (multigameParams, initData) => new EternalFortuneStack_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new EternalFortuneStack_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new EternalFortuneStack_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new EternalFortuneStack_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new EternalFortuneStack2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new EternalFortuneStack(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new EternalFortuneStack2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new EternalFortuneStack3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new EternalFortuneStack21(multigameParams, initData),

        },
        "AncientSea3D": {
            CreateGame_1_1s: (multigameParams, initData) => new AncientSea3D_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AncientSea3D_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AncientSea3D_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new AncientSea3D_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new AncientSea3D2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new AncientSea3D(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new AncientSea3D2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new AncientSea3D3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new AncientSea3D21(multigameParams, initData),


        },
        "SpiritsOfTheThunderReloaded": {
            CreateGame_1_1s: (multigameParams, initData) => new SpiritsOfTheThunderReloaded_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SpiritsOfTheThunderReloaded_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SpiritsOfTheThunderReloaded_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new SpiritsOfTheThunderReloaded_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SpiritsOfTheThunderReloaded2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SpiritsOfTheThunderReloaded(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SpiritsOfTheThunderReloaded2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SpiritsOfTheThunderReloaded3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SpiritsOfTheThunderReloaded21(multigameParams, initData),


        },
        "MysticCanyon": {
            CreateGame_1_1s: (multigameParams, initData) => new MysticCanyon_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MysticCanyon_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MysticCanyon_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MysticCanyon_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MysticCanyon2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MysticCanyon(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MysticCanyon2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MysticCanyon3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new MysticCanyon21(multigameParams, initData),


        },
        "AsianDreams": {
            CreateGame_1_1s: (multigameParams, initData) => new AsianDreams_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AsianDreams_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AsianDreams_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new AsianDreams_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new AsianDreams2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new AsianDreams(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new AsianDreams2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new AsianDreams3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new AsianDreams21(multigameParams, initData),


        },
        "MundoMistico": {
            CreateGame_1_1s: (multigameParams, initData) => new MundoMistico_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MundoMistico_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MundoMistico_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MundoMistico_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MundoMistico2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MundoMistico(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MundoMistico2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MundoMistico3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new MundoMistico21(multigameParams, initData),


        },
        "SecretsOfAnubisClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new SecretsOfAnubisClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SecretsOfAnubisClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SecretsOfAnubisClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new SecretsOfAnubisClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SecretsOfAnubisClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SecretsOfAnubisClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SecretsOfAnubisClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SecretsOfAnubisClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SecretsOfAnubisClassic21(multigameParams, initData),

        },
        "RoyalDice": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalDice_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RoyalDice_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RoyalDice2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RoyalDice(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RoyalDice2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RoyalDice3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RoyalDice21(multigameParams, initData),

        },
        "RoyalChalice": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalChalice_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalChalice_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalChalice_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RoyalChalice_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RoyalChalice2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RoyalChalice(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RoyalChalice2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RoyalChalice3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RoyalChalice21(multigameParams, initData),

        },
        "TikiBayClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new TikiBayClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new TikiBayClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new TikiBayClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new TikiBayClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new TikiBayClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new TikiBayClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new TikiBayClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new TikiBayClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new TikiBayClassic21(multigameParams, initData),

        },
        "WildChalice": {
            CreateGame_1_1s: (multigameParams, initData) => new WildChalice_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new WildChalice_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildChalice_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new WildChalice_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new WildChalice2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new WildChalice(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new WildChalice2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new WildChalice3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new WildChalice21(multigameParams, initData),

        },
        "RainbowMagicClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new RainbowMagicClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RainbowMagicClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RainbowMagicClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RainbowMagicClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RainbowMagicClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RainbowMagicClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RainbowMagicClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RainbowMagicClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RainbowMagicClassic21(multigameParams, initData),

        },
        "FairyMagicForestClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new FairyMagicForestClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FairyMagicForestClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FairyMagicForestClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new FairyMagicForestClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new FairyMagicForestClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new FairyMagicForestClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new FairyMagicForestClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new FairyMagicForestClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new FairyMagicForestClassic21(multigameParams, initData),

        },
        "WildFire100": {
            CreateGame_1_1s: (multigameParams, initData) => new WildFire100_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new WildFire100_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildFire100_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new WildFire100_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new WildFire100_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new WildFire100(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new WildFire100_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new WildFire100_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new WildFire10021(multigameParams, initData),

        },
        "WildFire20": {
            CreateGame_1_1s: (multigameParams, initData) => new WildFire20_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new WildFire20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildFire20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new WildFire20_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new WildFire20_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new WildFire20(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new WildFire20_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new WildFire20_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new WildFire2021(multigameParams, initData),

        },
        "SevenFeverClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new SevenFeverClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SevenFeverClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SevenFeverClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new SevenFeverClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SevenFeverClassic_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SevenFeverClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SevenFeverClassic_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SevenFeverClassic_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new SevenFeverClassic21(multigameParams, initData),

        },
        "LuckyFire5": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire5_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire5_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire5_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire5_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire52_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire5(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire52(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire53(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire521(multigameParams, initData),

        },
        "LuckyIce5": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce5_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce5_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce5_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce5_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce52_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce5(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce52(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce53(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce521(multigameParams, initData),

        },
        "IceBlastDeluxClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new IceBlastDeluxClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new IceBlastDeluxClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new IceBlastDeluxClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new IceBlastDeluxClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new IceBlastDeluxClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new IceBlastDeluxClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new IceBlastDeluxClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new IceBlastDeluxClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new IceBlastDeluxClassic21(multigameParams, initData),

        },
        "FireBlastDeluxClassic": {
            CreateGame_1_1s: (multigameParams, initData) => new FireBlastDeluxClassic_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new FireBlastDeluxClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new FireBlastDeluxClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new FireBlastDeluxClassic_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new FireBlastDeluxClassic2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new FireBlastDeluxClassic(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new FireBlastDeluxClassic2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new FireBlastDeluxClassic3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new FireBlastDeluxClassic21(multigameParams, initData),

        },
        "LuckyFire10": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire10_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire102_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire10(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire102(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire103(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire1021(multigameParams, initData),

        },
        "LuckyIce10": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce10_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce10_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce102_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce10(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce102(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce103(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce1021(multigameParams, initData),

        },
        "LuckyFire40Delux": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyFire40Delux_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire40Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire40Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyFire40Delux_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyFire40Delux_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyFire40Delux(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyFire40Delux_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyFire40Delux_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyFire40Delux21(multigameParams, initData),

        },
        "LuckyIce40Delux": {
            CreateGame_1_1s: (multigameParams, initData) => new LuckyIce40Delux_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LuckyIce40Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyIce40Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LuckyIce40Delux_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LuckyIce40Delux_2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LuckyIce40Delux(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LuckyIce40Delux_2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LuckyIce40Delux_3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new LuckyIce40Delux21(multigameParams, initData),

        },
        "RoyalKing": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalKing_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKing_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKing_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RoyalKing_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RoyalKing2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RoyalKing(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RoyalKing2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RoyalKing3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RoyalKing21(multigameParams, initData),

        },
        "RoyalKingDeluxe": {
            CreateGame_1_1s: (multigameParams, initData) => new RoyalKingDeluxe_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKingDeluxe_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKingDeluxe_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RoyalKingDeluxe_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RoyalKingDeluxe2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RoyalKingDeluxe(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RoyalKingDeluxe2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RoyalKingDeluxe3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new RoyalKingDeluxe21(multigameParams, initData),

        },
        "VintageSevenClassic": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new VintageSevenClassic_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new VintageSevenClassic_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },

        "CloverGirlGreen": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreen_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGreen_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlDiamond": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlDiamond_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlDiamond_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlGold": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGold_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGold_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlHot": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlHot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlHot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlDiamond40": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlDiamond40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlDiamond40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlDiamond40Deluxe": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlGold10": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGold10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGold10_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlGold10Deluxe": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGold10Deluxe_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGold10Deluxe_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlGreen20": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreen20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGreen20_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
           "CloverGirlGreen10": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreen10_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGreen10_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "LuckyFire50Delux": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire50Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire50Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "LuckyFire100Delux": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new LuckyFire100Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LuckyFire100Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RoyalDice5": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice5_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice5_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RoyalDice20Delux": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice20Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice20Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
            "RoyalDice40Delux": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice40Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice40Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RoyalDice40": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalDice40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalDice40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RoyalKing5": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKing5_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKing5_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RoyalKingDeluxe20": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKingDeluxe20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKingDeluxe20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RoyalKingDeluxe40": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new RoyalKingDeluxe40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RoyalKingDeluxe40_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
          "WildChalice40Delux": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new WildChalice40Delux_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildChalice40Delux_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "WildChalice20": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new WildChalice20_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new WildChalice20_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlGreen40": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreen40_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGreen40_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlGreen20Deluxe": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreen20Deluxe_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGreen20Deluxe_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlHot50": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlHot50_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlHot50_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "CloverGirlHot50Deluxe": {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlHot50Deluxe_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlHot50Deluxe_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "LavaLand2023": {
            CreateGame_1_1s: (multigameParams, initData) => new LavaLand2023_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LavaLand2023_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LavaLand2023_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LavaLand2023_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LavaLand20232_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LavaLand2023(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LavaLand20232(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LavaLand20233(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "RainbowMagic2023": {
            CreateGame_1_1s: (multigameParams, initData) => new RainbowMagic2023_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new RainbowMagic2023_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new RainbowMagic2023_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new RainbowMagic2023_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new RainbowMagic20232_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new RainbowMagic2023(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new RainbowMagic20232(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new RainbowMagic20233(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "VintageSeven":
        {
            CreateGame_1_1s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_Responsive: (multigameParams, initData) => new VintageSeven_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new VintageSeven_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_2s: (multigameParams, initData) => { throw new Error("Not implemented") },

            CreateGame_1_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_2_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_3_3s: (multigameParams, initData) => { throw new Error("Not implemented") },
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => { throw new Error("Not implemented") },
        },
        "MysticRainbow": {
            CreateGame_1_1s: (multigameParams, initData) => new MysticRainbow_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MysticRainbow_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MysticRainbow_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MysticRainbow_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MysticRainbow2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MysticRainbow(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MysticRainbow2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MysticRainbow3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => null,
            CreateGame21: (multigameParams, initData) => new MysticRainbow21(multigameParams, initData),

        },
        "MysticKingdom": {
            CreateGame_1_1s: (multigameParams, initData) => new MysticKingdom_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MysticKingdom_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MysticKingdom_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MysticKingdom_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MysticKingdom2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MysticKingdom(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MysticKingdom2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MysticKingdom3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => new MysticKingdom(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new MysticKingdom21(multigameParams, initData),

        },
        "MysticRainbowFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new MysticRainbowFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MysticRainbowFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MysticRainbowFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MysticRainbowFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MysticRainbowFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MysticRainbowFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MysticRainbowFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MysticRainbowFillingPot3(multigameParams, initData),

            CreateGame_PixiAPP: (multigameParams, initData) => new MysticRainbowFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new MysticRainbowFillingPot21(multigameParams, initData),

        },
        "EternalFortuneFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new EternalFortuneFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new EternalFortuneFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new EternalFortuneFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new EternalFortuneFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new EternalFortuneFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new EternalFortuneFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new EternalFortuneFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new EternalFortuneFillingPot3(multigameParams, initData),

            CreateGame_PixiAPP: (multigameParams, initData) => new EternalFortuneFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new EternalFortuneFillingPot21(multigameParams, initData),

        },
        "LavaLandMysticWarriorsFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot3(multigameParams, initData),

            CreateGame_PixiAPP: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new LavaLandMysticWarriorsFillingPot21(multigameParams, initData),

        },
        "MayanHeroesFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new MayanHeroesFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MayanHeroesFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MayanHeroesFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MayanHeroesFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MayanHeroesFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MayanHeroesFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MayanHeroesFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MayanHeroesFillingPot3(multigameParams, initData),

            CreateGame_PixiAPP: (multigameParams, initData) => new MayanHeroesFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new MayanHeroesFillingPot21(multigameParams, initData),

        },
        "AncientSea3DFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new AncientSea3DFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new AncientSea3DFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new AncientSea3DFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new AncientSea3DFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new AncientSea3DFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new AncientSea3DFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new AncientSea3DFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new AncientSea3DFillingPot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => new AncientSea3DFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new AncientSea3DFillingPot21(multigameParams, initData),

        },
        "CloverGirlGreenFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new CloverGirlGreenFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreenFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGreenFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new CloverGirlGreenFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new CloverGirlGreenFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new CloverGirlGreenFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new CloverGirlGreenFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new CloverGirlGreenFillingPot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => new CloverGirlGreenFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new CloverGirlGreenFillingPot21(multigameParams, initData),

        },
        // "CloverGirlGreenFillingPotMB": {
        //     CreateGame_1_1s: (multigameParams, initData) => new CloverGirlGreenFillingPotMB_1Screen(multigameParams, initData),
        //     CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGreen_Responsive(multigameParams, initData),
        //     CreateGame_ResponsivePIXIAPP:(multigameParams, initData) => new CloverGirlGreen_ResponsivePIXIApp(multigameParams, initData),

        //     CreateGame_1_2s: (multigameParams, initData) => new CloverGirlGreenFillingPotMB_2Screen(multigameParams, initData),
        //     CreateGame_2_2s: (multigameParams, initData) => new CloverGirlGreenFillingPotMB2_2Screen(multigameParams, initData),

        //     CreateGame_1_3s: (multigameParams, initData) => new CloverGirlGreenFillingPotMB(multigameParams, initData),
        //     CreateGame_2_3s: (multigameParams, initData) => new CloverGirlGreenFillingPotMB2(multigameParams, initData),
        //     CreateGame_3_3s: (multigameParams, initData) => new CloverGirlGreenFillingPotMB3(multigameParams, initData),
        //     CreateGame_PixiAPP: (multigameParams, initData) => new CloverGirlGreenFillingPotMB(multigameParams, initData),
        //     CreateGame21: (multigameParams, initData) => new CloverGirlGreenFillingPotMB21(multigameParams, initData),
        // },
        "CloverGirlHotFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new CloverGirlHotFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlHotFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlHotFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new CloverGirlHotFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new CloverGirlHotFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new CloverGirlHotFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new CloverGirlHotFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new CloverGirlHotFillingPot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => new CloverGirlHotFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new CloverGirlHotFillingPot21(multigameParams, initData),

        },
        "CloverGirlDiamondFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new CloverGirlDiamondFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlDiamondFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlDiamondFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new CloverGirlDiamondFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new CloverGirlDiamondFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new CloverGirlDiamondFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new CloverGirlDiamondFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new CloverGirlDiamondFillingPot3(multigameParams, initData),


            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new CloverGirlDiamondFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new CloverGirlDiamondFillingPot21(multigameParams, initData),

        },
        "CloverGirlGoldFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new CloverGirlGoldFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new CloverGirlGoldFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new CloverGirlGoldFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new CloverGirlGoldFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new CloverGirlGoldFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new CloverGirlGoldFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new CloverGirlGoldFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new CloverGirlGoldFillingPot3(multigameParams, initData),
            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new CloverGirlGoldFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new CloverGirlGoldFillingPot21(multigameParams, initData),

        },
        "MysticKingdomFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new MysticKingdomFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new MysticKingdomFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new MysticKingdomFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new MysticKingdomFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new MysticKingdomFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new MysticKingdomFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new MysticKingdomFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new MysticKingdomFillingPot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => new MysticKingdomFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new MysticKingdomFillingPot21(multigameParams, initData),

        },
        "SpiritsOfTheThunderFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot3(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot21(multigameParams, initData),


            CreateGame_PixiAPP: (multigameParams, initData) => new SpiritsOfTheThunderFillingPot(multigameParams, initData),
        },
        "NordicFuryFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new NordicFuryFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new NordicFuryFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new NordicFuryFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new NordicFuryFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new NordicFuryFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new NordicFuryFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new NordicFuryFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new NordicFuryFillingPot3(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => null,
            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new NordicFuryFillingPot(multigameParams, initData),
        },
        "NordicFuryMB": {
            CreateGame_1_1s: (multigameParams, initData) => new NordicFuryMB_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new NordicFuryMB_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new NordicFuryFillingMB_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new NordicFuryMB_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new NordicFuryMB2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new NordicFuryMB(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new NordicFuryMB2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new NordicFuryMB3(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new NordicFuryMB21(multigameParams, initData),
            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new NordicFuryMB(multigameParams, initData),
        },
        "GoldAndRumBAFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new GoldAndRumBAFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new GoldAndRumBAFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new GoldAndRumBAFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new GoldAndRumBAFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new GoldAndRumBAFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new GoldAndRumBAFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new GoldAndRumBAFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GoldAndRumBAFillingPot3(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new GoldAndRumBAFillingPot21(multigameParams, initData),
            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GoldAndRumBAFillingPot(multigameParams, initData),
        },
        "GoldAndRumAhoyFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new GoldAndRumAhoyFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new GoldAndRumAhoyFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new GoldAndRumAhoyFillingPot_ResponsivePIXIApp(multigameParams, initData),

            CreateGame_1_2s: (multigameParams, initData) => new GoldAndRumAhoyFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new GoldAndRumAhoyFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new GoldAndRumAhoyFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new GoldAndRumAhoyFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GoldAndRumAhoyFillingPot3(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new GoldAndRumAhoyFillingPot21(multigameParams, initData),
            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GoldAndRumAhoyFillingPot(multigameParams, initData),
        },
        "GoldAndRumAhoyFillingPotN": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game GoldAndRumAhoyFillingPotN not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "GoldAndRumAhoyFillingPotN"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "GoldAndRumAhoyFillingPotN"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game GoldAndRumAhoyFillingPotN not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game GoldAndRumAhoyFillingPotN not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "GoldAndRumAhoyFillingPotN"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "GoldAndRumAhoyFillingPotN"),
        },
        "BambooSecretsFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => new BambooSecretsFillingPot_1Screen(multigameParams, initData),
            CreateGame_Responsive: (multigameParams, initData) => new BambooSecretsFillingPot_Responsive(multigameParams, initData),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new BambooSecretsFillingPot_ResponsivePIXIApp(multigameParams, initData),


            CreateGame_1_2s: (multigameParams, initData) => new BambooSecretsFillingPot_2Screen(multigameParams, initData),
            CreateGame_2_2s: (multigameParams, initData) => new BambooSecretsFillingPot2_2Screen(multigameParams, initData),

            CreateGame_1_3s: (multigameParams, initData) => new BambooSecretsFillingPot(multigameParams, initData),
            CreateGame_2_3s: (multigameParams, initData) => new BambooSecretsFillingPot2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new BambooSecretsFillingPot3(multigameParams, initData),
            CreateGame_PixiAPP: (multigameParams, initData) => new BambooSecretsFillingPot(multigameParams, initData),
            CreateGame21: (multigameParams, initData) => new BambooSecretsFillingPot21(multigameParams, initData),
        },
        "BambooSecretsMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game BambooSecretsMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "BambooSecretsMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "BambooSecretsMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game BambooSecretsMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game BambooSecretsMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "BambooSecretsMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "BambooSecretsMB"),
        },
        "MysticNightMB":{
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game MysticNightMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "MysticNightMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "MysticNightMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game MysticNightMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game MysticNightMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "MysticNightMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "MysticNightMB"),

        },
        "MysticNightFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game MysticNightFillingPot not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "MysticNightFillingPot"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "MysticNightFillingPot"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game MysticNightFillingPot not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game MysticNightFillingPot not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "MysticNightFillingPot"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "MysticNightFillingPot"),

        },
        "SecretsOfAnubisMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game SecretsOfAnubisMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "SecretsOfAnubisMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "SecretsOfAnubisMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SecretsOfAnubisMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SecretsOfAnubisMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SecretsOfAnubisMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SecretsOfAnubisMB"),
        },
        "LavaLandMysticWarriorsMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game LavaLandMysticWarriorsMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "LavaLandMysticWarriorsMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "LavaLandMysticWarriorsMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game LavaLandMysticWarriorsMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game LavaLandMysticWarriorsMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "LavaLandMysticWarriorsMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "LavaLandMysticWarriorsMB"),
        },
        "CloverGirlGreenFillingPotMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game CloverGirlGreenFillingPotMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "CloverGirlGreenFillingPotMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "CloverGirlGreenFillingPotMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game CloverGirlGreenFillingPotMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game CloverGirlGreenFillingPotMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "CloverGirlGreenFillingPotMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "CloverGirlGreenFillingPotMB"),
        },
        "SpiritsOfTheThunderMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game SpiritsOfTheThunderMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "SpiritsOfTheThunderMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "SpiritsOfTheThunderMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SpiritsOfTheThunderMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SpiritsOfTheThunderMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SpiritsOfTheThunderMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            //new game Engine
            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SpiritsOfTheThunderMB"),
        },
        "SevenFeverFillingPot": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game SevenFeverFillingPot not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "SevenFeverFillingPot"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "SevenFeverFillingPot"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SevenFeverFillingPot not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SevenFeverFillingPot not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SevenFeverFillingPot"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),


            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SevenFeverFillingPot"),
        },
        "SevenFeverMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game SevenFeverMB not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "SevenFeverMB"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "SevenFeverMB"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game SevenFeverMB not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game SevenFeverMB not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SevenFeverMB"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),


            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "SevenFeverMB"),
        },
        "MysticRainbowMBRemake": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game MysticRainbowMBRemake not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "MysticRainbowMBRemake"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "MysticRainbowMBRemake"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game MysticRainbowMBRemake not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game MysticRainbowMBRemake not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "MysticRainbowMBRemake"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),


            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "MysticRainbowMBRemake"),
        },
        "EternalFortuneMBRemake": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "MysticRainbowMBRemake"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "MysticRainbowMBRemake"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "EternalFortuneMBRemake"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),


            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "EternalFortuneMBRemake"),
        },
        "MysticKingdomMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "MysticRainbowMBRemake"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "MysticRainbowMBRemake"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "EternalFortuneMBRemake"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),


            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "EternalFortuneMBRemake"),
        },
        "StickyChilliMB": {
            CreateGame_1_1s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },
            CreateGame_Responsive: (multigameParams, initData) => new Generic_Responsive(multigameParams, initData, "MysticRainbowMBRemake"),
            CreateGame_ResponsivePIXIAPP: (multigameParams, initData) => new Generic_ResponsivePIXIApp(multigameParams, initData, "MysticRainbowMBRemake"),

            CreateGame_1_2s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },
            CreateGame_2_2s: (multigameParams, initData) => { throw "Game EternalFortuneMBRemake not implemented" },

            CreateGame_1_3s: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "EternalFortuneMBRemake"),
            CreateGame_2_3s: (multigameParams, initData) => new GenericGame2(multigameParams, initData),
            CreateGame_3_3s: (multigameParams, initData) => new GenericGame3(multigameParams, initData),

            CreateGame21: (multigameParams, initData) => new GenericGame21(multigameParams, initData),

            CreateGame_PixiAPP: (multigameParams, initData) => new GenericGame1(multigameParams, initData, "EternalFortuneMBRemake"),
        },
    }

    public GetFactory(gameName: string): IGameFactory {
        const factory = this.registeredGames[gameName];
        if (!factory) {
            console.error(`Game ${gameName} not implemented (missing in game factory)`);
            throw `Game ${gameName} not implemented (missing in game factory)`;
        }
        return factory;
    }
}
